import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { delay, formatBillingIntervalDays, formatMoney, isDefined, isObjectEmpty } from "../_helpers";
import {
  AccountService,
  AlertService,
  DashboardService,
  LoaderService,
  SideNavService,
  StorageService,
  UserService,
} from "../_services";
import {
  Account,
  CanceledWithPendingOrderResponse,
  CancellationReasonRow,
  CustomerSupportMarketplaceSummary,
  CustomerSupportOverview,
  CustomerSupportOverviewTrend,
  CustomerSupportPortalMoment,
  CustomerSupportSummary,
  CustomerSupportTopFaq,
  CustomerSupportSummaryAPIResponse,
  DashboardFilter,
  DashboardNavFilters,
  DashboardMarketplaceCampaignAPIResponse,
  DashboardMarketplaceProductConversionsAPIResponse,
  DashboardMarketplaceSalesAPIResponse,
  DashboardMarketplaceSummaryAPIResponse,
  DashboardMarketplaceTopCardsAPIResponse,
  DashboardMarketplaceTotalVisitorsAPIResponse,
  DashboardMarketplaceWatchlist,
  DashboardRetentionDeflectionDataAPIResponse,
  DashboardRetentionStatisticsAPIResponse,
  DashboardRetentionWatchlistAPIResponse,
  DashboardSections,
  DashboardAdminOnlySections,
  DashboardBetaSections,
  DashboardSectionLabels,
  DashboardSectionPage,
  DashboardReportSection,
  DashboardSessionResultsAPIResponse,
  GroupedChartRow,
  InfoCards,
  KpiCard,
  KpiCardKey,
  KpiCardsResponse,
  MarketplaceCampaign,
  MarketplaceProductConversion,
  MarketplaceSummary,
  MarketplaceTopCards,
  MarketplaceVisitor,
  MoneyCard,
  MoneyCardKey,
  MoneyCardsResponse,
  OfferTypeResponse,
  OfferTypeRow,
  OpenReturnActivityResponse,
  OverviewRefundsSummary,
  OverviewRefundsSummaryAPIResponse,
  Pager,
  PerformanceRow,
  PortalActionScope,
  PerformanceTableResponse,
  RetentionDeflectionData,
  RetentionDownsellAPIResponse,
  RetentionDownsellData,
  RetentionMiscDataAPIResponse,
  RetentionSegment,
  RetentionSummaryData,
  RetentionSummaryV2Response,
  RetentionWatchlist,
  ReturnsAiInsightIconMap,
  ReturnsAiInsightRule,
  ReturnsOfferApiRow,
  SessionResult,
  StepCategoryLabels,
  TopCancellationReasonsResponse,
  User,
  AiInsightApiRow,
  AiInsightsResponse,
  TopOffersResponse,
} from "../_models";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as moment from "moment";
import { takeUntil } from "rxjs/operators";
import { config } from "../../config/config";
import { Observable, Subject } from "rxjs";
import {
  OverviewSessionsService,
  OverviewRefundsSummaryService,
  OverviewOrderCancellationReasonsService,
  OverviewOrderMoneyCardsService,
  OverviewOrderKpiCardsService,
  OverviewSubscriptionKpiCardsService,
  OverviewSubscriptionMoneyCardsService,
  OverviewTopIntentsService,
  OverviewOrderPortalActionsService,
  OverviewPortalMomentsService,
  OverviewSubscriptionCancellationReasonsService,
  OverviewReturnCancellationReasonsService,
  OverviewReturnsKpiCardsService,
  OverviewReturnsMoneyCardsService,
  OverviewReturnsOpenActivityService,
} from "../_services/dashboard/overview";
import {
  MarketplaceSummaryIndex,
  OverviewDualCard,
  OverviewDualCardIndex,
  OverviewInfo,
  ResolvePerformanceStatIndex,
  ReturnSummaryDualIndex,
  ReturnSummaryIndex,
  SupportSummaryIndex,
  OverviewCardState,
  applyPortalActionsScope,
  applyTopIntents,
  faqs,
  mapPortalActionRows,
  marketplaceSummaryInfoCards,
  overviewDualCards,
  overviewInfoCardsData,
  overviewSummaryHasActivity,
  overviewTopSingleCards,
  portalActions,
  portalMoments,
  refundAmountPrefix,
  resetOverviewSummaryActivity,
  resolvePerformanceStats,
  returnSummaryDualCards,
  returnSummaryInfoCards,
  sessionFinalizationHours,
  sessions,
  sessionsDoughnutData,
  sessionsTableData,
  supportSummaryInfoCards,
  topIntentsDoughnutData,
  topOrderCancellationReasons,
  topSubscriptionCancellationReasons,
  topReturnReasons,
} from "./overview";
import {
  DefaultTableRecord,
  DoughnutChartData,
  InlineTableData,
  ProductReturnPerfRow,
} from "./data-visualization";
import {
  RetentionDeflectionDataService,
  RetentionStatisticsService,
  RetentionWatchlistService,
  RetentionDownsellService,
  RetentionSummaryService,
  RetentionMiscDataService,
} from "../_services/dashboard/retention";
import {
  RetentionInfoMid,
  RetentionInfoTop,
  RetentionWatchlistFields,
  cancellationData,
  cancellationTableData,
  deflection,
  downsells,
  pathBreakdowns,
  retentionMidCards,
  retentionTopCards,
  summaryTableData,
  summmaryData,
  surveys,
  watchlist,
} from "./retention/retention.data";
import {
  MarketplaceCampaignService,
  MarketplaceProductConversionsService,
  MarketplaceSalesService,
  MarketplaceSummaryService,
  MarketplaceTopCardsService,
  MarketplaceTotalVisitorsService,
  MarketplaceWatchlistService,
} from "../_services/dashboard/marketplace";
import {
  MarketplaceInfo,
  campaignConversions,
  marketplaceDoughnutData,
  marketplaceInfoCards,
  marketplaceTableData,
  marketplaceWatchlist,
  productConversions,
  saleResponses,
  visitors,
} from "./marketplace/marketplace.data";
import {
  SubscriptionTopCardsService,
  SubscriptionSummaryService,
  SubscriptionCancellationReasonsService,
  SubscriptionOfferTypeService,
  SubscriptionProductService,
  SubscriptionCampaignProductService,
  SubscriptionBillingCycleService,
  SubscriptionFrequencyService,
  SubscriptionCampaignService,
  SubscriptionCustomerStageService,
  SubscriptionCanceledWithPendingOrderService,
} from "../_services/dashboard/subscription";
import {
  OrdersKpiCardsService,
  OrdersRetentionSummaryService,
  OrdersCancellationReasonsService,
  OrdersMoneyCardsService,
  OrdersOfferTypeService,
  OrdersProductService,
  OrdersCampaignProductService,
  OrdersCampaignService,
  OrdersCustomerStageService,
  OrdersMessageService,
} from "../_services/dashboard/orders";
import {
  ordersTopCards,
  ordersDoughnutData,
  ordersSummaryTableData,
  ordersCancellationReasons,
  ordersBillingDualCards,
  ordersBillingSingleCards,
  ordersBillingState,
  ordersOfferTypeData,
  ordersProductData,
  ordersCampaignData,
  ordersCustomerStageData,
  OrdersInfo,
  ProductViewType,
} from "./orders/orders.data";
import {
  SubscriptionInfo,
  canceledWithPendingOrderData,
  subscriptionBillingCycleData,
  subscriptionCampaignData,
  subscriptionCancellationReasons,
  subscriptionCustomerStageData,
  subscriptionDoughnutData,
  subscriptionFrequencyData,
  subscriptionOfferTypeData,
  subscriptionProductData,
  subscriptionSummaryTableData,
  subscriptionTopCards,
} from "./subscription/subscription.data";
import {
  ReturnsKpiCardsService,
  ReturnsMoneyCardsService,
  ReturnsRetentionSummaryService,
  ReturnsOpenActivityService,
  ReturnsReasonsService,
  ReturnsProductService,
  ReturnsOffersService,
  ReturnsAiInsightsService,
} from "../_services/dashboard/returns";
import {
  returnsTopCards,
  returnsOutcomesData,
  returnsOutcomesLegend,
  returnsActivityStats,
  returnsReasons,
  returnsProducts,
  returnsOffers,
  returnsAiInsights,
  ReturnsCardIndex,
  ReturnsKpiCard,
  ReturnsKpiSubMetricKey,
  ReturnsTableRow,
  ReturnsOfferRow,
  ReturnsAiInsight,
} from "./returns/returns.data";
import {
  pdfReportFooterHeightIn,
  pdfReportHeaderHeightIn,
  pdfReportPageHeightIn,
  pdfReportPagePaddingIn,
  pdfReportPageSlices,
  pdfReportPageWidthIn,
} from "./reports";
import { DashboardFilterBarComponent } from "./dashboard-filter-bar/dashboard-filter-bar.component";


@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements AfterViewInit, OnInit {
  @ViewChild(DashboardFilterBarComponent, { static: false }) filterBar: DashboardFilterBarComponent;
  selectedSection: DashboardSections;
  selectedFilters: DashboardFilter = null;
  dashboardSections = DashboardSections;
  dashboardSectionLabels = DashboardSectionLabels;
  dashboardBetaSections = DashboardBetaSections;
  dashboardAdminOnlySections = DashboardAdminOnlySections;
  pageSections: DashboardSections[] = [DashboardSections.Overview];
  isReportDownloading: boolean = false;
  showOverviewReport: boolean = false;
  viewReport: DashboardSections;
  accounts: Account[] = [];
  currentUser: User;
  sectionDataInitialized: Set<DashboardSections> = new Set<DashboardSections>();

  protected overviewServicesMap = {};
  protected retentionServicesMap = {};
  protected marketplaceServicesMap = {};
  protected subscriptionServicesMap = {};

  /* OVERVIEW */
  // Misc
  isObjectEmpty = isObjectEmpty;

  // Cards Data
  infoCards: InfoCards = overviewInfoCardsData;
  overviewDualCards = overviewDualCards;
  overviewTopSingleCards: InfoCards = overviewTopSingleCards;
  overviewDualCardIndex = OverviewDualCardIndex;
  resolvePerformanceStats = resolvePerformanceStats;
  topOrderCancellationReasons = topOrderCancellationReasons;
  topSubscriptionCancellationReasons = topSubscriptionCancellationReasons;
  topReturnReasons = topReturnReasons;
  portalMoments = portalMoments;
  portalActions = portalActions;
  resolvePerformanceStatIndex = ResolvePerformanceStatIndex;
  overviewOrderKpiLoading: boolean = false;
  overviewSubscriptionKpiLoading: boolean = false;
  private overviewOrderSavedRevenue: MoneyCard = null;
  private overviewSubscriptionSavedRevenue: MoneyCard = null;

  // Charts Data
  sessionsDoughnutData: DoughnutChartData = sessionsDoughnutData;
  sessionsTableData: InlineTableData = sessionsTableData;
  sessions = sessions;

  /* RETENTION */
  // Cards Data
  retentionTopCards: InfoCards = retentionTopCards;
  retentionMidCards: InfoCards = retentionMidCards;

  // Charts Data
  summaryData: DoughnutChartData = summmaryData;
  summaryTableData: InlineTableData = summaryTableData;
  cancellationData: DoughnutChartData = cancellationData;
  cancellationTableData: InlineTableData = cancellationTableData;
  surveyResponses = surveys;
  downsells = downsells;
  deflection = deflection;
  watchlist = watchlist;
  pathBreakdowns = pathBreakdowns;

  /* MARKETPLACE */
  // Cards Data
  marketplaceInfoCardsData: InfoCards = marketplaceInfoCards;

  // Charts Data
  marketplaceDoughnutData: DoughnutChartData = marketplaceDoughnutData;
  marketplaceTableData: InlineTableData = marketplaceTableData;
  saleResponses = saleResponses;
  visitors = visitors;
  productConversions = productConversions;
  campaignConversions = campaignConversions;
  activeWatchlists = marketplaceWatchlist;

  /* SUBSCRIPTION */
  // Cards Data
  subscriptionTopCardsData: InfoCards = subscriptionTopCards;
  subscriptionInfoEnum = SubscriptionInfo;

  // Charts Data
  subscriptionDoughnutData: DoughnutChartData = subscriptionDoughnutData;
  subscriptionSummaryTableData: InlineTableData = subscriptionSummaryTableData;
  subscriptionCancellationReasons = subscriptionCancellationReasons;
  subscriptionOfferTypeData = subscriptionOfferTypeData;
  subscriptionProductData = subscriptionProductData;
  subscriptionBillingCycleData = subscriptionBillingCycleData;
  subscriptionFrequencyData = subscriptionFrequencyData;
  subscriptionCampaignData = subscriptionCampaignData;
  subscriptionCustomerStageData = subscriptionCustomerStageData;
  canceledWithPendingOrderData = canceledWithPendingOrderData;

  /* ORDERS */
  // Cards Data
  ordersTopCardsData: InfoCards = ordersTopCards;
  ordersInfoEnum = OrdersInfo;

  // Charts Data
  ordersDoughnutData = ordersDoughnutData;
  ordersSummaryTableData = ordersSummaryTableData;
  ordersCancellationReasons = ordersCancellationReasons;
  ordersOfferTypeData = ordersOfferTypeData;
  ordersProductData = ordersProductData;
  ordersCampaignData = ordersCampaignData;
  ordersCustomerStageData = ordersCustomerStageData;

  // Billing Row
  ordersBillingDualCards = ordersBillingDualCards;
  ordersBillingSingleCards = ordersBillingSingleCards;
  kpiCardsLoading: boolean = false;
  protected ordersServicesMap = {};

  /* RETURNS */
  returnsTopCards = returnsTopCards;
  returnsOutcomesData = returnsOutcomesData;
  returnsOutcomesLegend = returnsOutcomesLegend;
  returnsActivityStats = returnsActivityStats;
  returnsActivityLoading: boolean = false;
  returnsMoneyCardsLoading: boolean = false;
  returnsReasons = returnsReasons;
  returnsProducts = returnsProducts;
  returnsOffers = returnsOffers;
  returnsAiInsights = returnsAiInsights;
  protected returnsServicesMap = {};

  protected _destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private loader: LoaderService,
    private accountService: AccountService,
    private dashboardService: DashboardService,
    protected overviewRefundsSummaryService: OverviewRefundsSummaryService,
    protected overviewOrderCancellationReasonsService: OverviewOrderCancellationReasonsService,
    protected overviewOrderMoneyCardsService: OverviewOrderMoneyCardsService,
    protected overviewSubscriptionMoneyCardsService: OverviewSubscriptionMoneyCardsService,
    protected overviewSubscriptionCancellationReasonsService: OverviewSubscriptionCancellationReasonsService,
    protected overviewReturnCancellationReasonsService: OverviewReturnCancellationReasonsService,
    protected overviewOrderKpiCardsService: OverviewOrderKpiCardsService,
    protected overviewSubscriptionKpiCardsService: OverviewSubscriptionKpiCardsService,
    protected overviewTopIntentsService: OverviewTopIntentsService,
    protected overviewOrderPortalActionsService: OverviewOrderPortalActionsService,
    protected overviewPortalMomentsService: OverviewPortalMomentsService,
    protected overviewReturnsKpiCardsService: OverviewReturnsKpiCardsService,
    protected overviewReturnsMoneyCardsService: OverviewReturnsMoneyCardsService,
    protected overviewReturnsOpenActivityService: OverviewReturnsOpenActivityService,
    protected dashboardSessionService: OverviewSessionsService,
    protected retentionMiscDataService: RetentionMiscDataService,
    protected retentionDeflectionDataService: RetentionDeflectionDataService,
    protected retentionStatisticsService: RetentionStatisticsService,
    protected retentionWatchlistService: RetentionWatchlistService,
    protected retentionDownsellService: RetentionDownsellService,
    protected retentionSummaryService: RetentionSummaryService,
    protected marketplaceCampaignService: MarketplaceCampaignService,
    protected marketplaceProductConversionsService: MarketplaceProductConversionsService,
    protected marketplaceSalesService: MarketplaceSalesService,
    protected marketplaceSummaryService: MarketplaceSummaryService,
    protected marketplaceTopCardsService: MarketplaceTopCardsService,
    protected marketplaceTotalVisitorsService: MarketplaceTotalVisitorsService,
    protected marketplaceWatchlistService: MarketplaceWatchlistService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected subscriptionTopCardsService: SubscriptionTopCardsService,
    protected subscriptionSummaryService: SubscriptionSummaryService,
    protected subscriptionCancellationReasonsService: SubscriptionCancellationReasonsService,
    protected subscriptionOfferTypeService: SubscriptionOfferTypeService,
    protected subscriptionProductService: SubscriptionProductService,
    protected subscriptionCampaignProductService: SubscriptionCampaignProductService,
    protected subscriptionBillingCycleService: SubscriptionBillingCycleService,
    protected subscriptionFrequencyService: SubscriptionFrequencyService,
    protected subscriptionCampaignService: SubscriptionCampaignService,
    protected subscriptionCustomerStageService: SubscriptionCustomerStageService,
    protected subscriptionCanceledWithPendingOrderService: SubscriptionCanceledWithPendingOrderService,
    protected ordersKpiCardsService: OrdersKpiCardsService,
    protected ordersRetentionSummaryService: OrdersRetentionSummaryService,
    protected ordersCancellationReasonsService: OrdersCancellationReasonsService,
    protected ordersMoneyCardsService: OrdersMoneyCardsService,
    protected ordersOfferTypeService: OrdersOfferTypeService,
    protected ordersProductService: OrdersProductService,
    protected ordersCampaignProductService: OrdersCampaignProductService,
    protected ordersCampaignService: OrdersCampaignService,
    protected ordersCustomerStageService: OrdersCustomerStageService,
    protected ordersMessageService: OrdersMessageService,
    protected returnsKpiCardsService: ReturnsKpiCardsService,
    protected returnsMoneyCardsService: ReturnsMoneyCardsService,
    protected returnsRetentionSummaryService: ReturnsRetentionSummaryService,
    protected returnsOpenActivityService: ReturnsOpenActivityService,
    protected returnsReasonsService: ReturnsReasonsService,
    protected returnsProductService: ReturnsProductService,
    protected returnsOffersService: ReturnsOffersService,
    protected returnsAiInsightsService: ReturnsAiInsightsService,
    private storageService: StorageService,
    private sideNavService: SideNavService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.overviewServicesMap["overviewRefundsSummaryService"] = overviewRefundsSummaryService;
    this.overviewServicesMap["overviewOrderCancellationReasonsService"] = overviewOrderCancellationReasonsService;
    this.overviewServicesMap["overviewOrderMoneyCardsService"] = overviewOrderMoneyCardsService;
    this.overviewServicesMap["overviewSubscriptionMoneyCardsService"] = overviewSubscriptionMoneyCardsService;
    this.overviewServicesMap["overviewSubscriptionCancellationReasonsService"] = overviewSubscriptionCancellationReasonsService;
    this.overviewServicesMap["overviewReturnCancellationReasonsService"] = overviewReturnCancellationReasonsService;
    this.overviewServicesMap["overviewOrderKpiCardsService"] = overviewOrderKpiCardsService;
    this.overviewServicesMap["overviewSubscriptionKpiCardsService"] = overviewSubscriptionKpiCardsService;
    this.overviewServicesMap["overviewTopIntentsService"] = overviewTopIntentsService;
    this.overviewServicesMap["overviewPortalMomentsService"] = overviewPortalMomentsService;
    this.overviewServicesMap["overviewReturnsKpiCardsService"] = overviewReturnsKpiCardsService;
    this.overviewServicesMap["overviewReturnsMoneyCardsService"] = overviewReturnsMoneyCardsService;
    this.overviewServicesMap["overviewReturnsOpenActivityService"] = overviewReturnsOpenActivityService;
    this.retentionServicesMap["retentionMiscDataService"] =
      retentionMiscDataService;
    this.retentionServicesMap["retentionDeflectionDataService"] =
      retentionDeflectionDataService;
    this.retentionServicesMap["retentionStatisticsService"] =
      retentionStatisticsService;
    this.retentionServicesMap["retentionWatchlistService"] =
      retentionWatchlistService;
    this.retentionServicesMap["retentionSummaryService"] =
      retentionSummaryService;
    this.marketplaceServicesMap["marketplaceCampaignService"] =
      marketplaceCampaignService;
    this.marketplaceServicesMap["marketplaceProductConversionsService"] =
      marketplaceProductConversionsService;
    this.marketplaceServicesMap["marketplaceSalesService"] =
      marketplaceSalesService;
    this.marketplaceServicesMap["marketplaceSummaryService"] =
      marketplaceSummaryService;
    this.marketplaceServicesMap["marketplaceTopCardsService"] =
      marketplaceTopCardsService;
    this.marketplaceServicesMap["marketplaceTotalVisitorsService"] =
      marketplaceTotalVisitorsService;
    this.marketplaceServicesMap["marketplaceWatchlistService"] =
      marketplaceWatchlistService;
    this.subscriptionServicesMap["subscriptionTopCardsService"] =
      subscriptionTopCardsService;
    this.subscriptionServicesMap["subscriptionSummaryService"] =
      subscriptionSummaryService;
    this.subscriptionServicesMap["subscriptionCancellationReasonsService"] =
      subscriptionCancellationReasonsService;
    this.subscriptionServicesMap["subscriptionOfferTypeService"] =
      subscriptionOfferTypeService;
    this.subscriptionServicesMap["subscriptionProductService"] =
      subscriptionProductService;
    this.subscriptionServicesMap["subscriptionCampaignProductService"] =
      subscriptionCampaignProductService;
    this.subscriptionServicesMap["subscriptionBillingCycleService"] =
      subscriptionBillingCycleService;
    this.subscriptionServicesMap["subscriptionFrequencyService"] =
      subscriptionFrequencyService;
    this.subscriptionServicesMap["subscriptionCampaignService"] =
      subscriptionCampaignService;
    this.subscriptionServicesMap["subscriptionCustomerStageService"] =
      subscriptionCustomerStageService;
    this.subscriptionServicesMap["subscriptionCanceledWithPendingOrderService"] =
      subscriptionCanceledWithPendingOrderService;
    this.ordersServicesMap["ordersKpiCardsService"] =
      ordersKpiCardsService;
    this.ordersServicesMap["ordersRetentionSummaryService"] =
      ordersRetentionSummaryService;
    this.ordersServicesMap["ordersCancellationReasonsService"] =
      ordersCancellationReasonsService;
    this.ordersServicesMap["ordersMoneyCardsService"] =
      ordersMoneyCardsService;
    this.ordersServicesMap["ordersOfferTypeService"] =
      ordersOfferTypeService;
    this.ordersServicesMap["ordersProductService"] =
      ordersProductService;
    this.ordersServicesMap["ordersCampaignProductService"] =
      ordersCampaignProductService;
    this.ordersServicesMap["ordersCampaignService"] =
      ordersCampaignService;
    this.ordersServicesMap["ordersCustomerStageService"] =
      ordersCustomerStageService;
    this.ordersServicesMap["ordersMessageService"] =
      ordersMessageService;
    this.returnsServicesMap["returnsKpiCardsService"] = returnsKpiCardsService;
    this.returnsServicesMap["returnsMoneyCardsService"] = returnsMoneyCardsService;
    this.returnsServicesMap["returnsRetentionSummaryService"] = returnsRetentionSummaryService;
    this.returnsServicesMap["returnsOpenActivityService"] = returnsOpenActivityService;
    this.returnsServicesMap["returnsReasonsService"] = returnsReasonsService;
    this.returnsServicesMap["returnsProductService"] = returnsProductService;
    this.returnsServicesMap["returnsOffersService"] = returnsOffersService;
    this.returnsServicesMap["returnsAiInsightsService"] = returnsAiInsightsService;
    this.selectedSection = DashboardSections.Overview;
  }

  ngOnInit(): void {
    this.setSectionFromRoute();
    this.setAccountID();
    this.getAccountsList();
    this.getSectionData();
    this.getDashboardData();
    this.getCurrentUser();
    this.collapseNavForRetentionSections();
  }

  getSectionData() {
    // guard: data$ subscriptions set up once per section to avoid BehaviorSubject replay clearing loaders
    if (!this.sectionDataInitialized.has(this.selectedSection)) {
      this.sectionDataInitialized.add(this.selectedSection);

      /* OVERVIEW */
      if (this.selectedSection === DashboardSections.Overview) {
        this.getSessionsData();
        this.getOverviewRefundsSummary();
        this.getOverviewOrderCancellationReasonsData();
        this.getOverviewOrderMoneyCardsData();
        this.getOverviewSubscriptionMoneyCardsData();
        this.getOverviewSubscriptionCancellationReasonsData();
        this.getOverviewReturnCancellationReasonsData();
        this.getOverviewOrderKpiCardsData();
        this.getOverviewSubscriptionKpiCardsData();
        this.getOverviewTopIntentsData();
        this.getOverviewPortalMomentsData();
        this.getOverviewOrderPortalActionsData();
        this.getOverviewReturnsKpiCardsData();
        this.getOverviewReturnsMoneyCardsData();
        this.getOverviewReturnsOpenActivityData();
      } else if (this.selectedSection === DashboardSections.Retention) {
        /* RETENTION */
        this.getMiscData();
        this.getStatisticsData();
        this.getRetentionSummary();
        // this.getRetentionCancelCategoriesData();
        // this.getDownsellData();
        this.getDeflectionData();
        this.getWatchlistData();
      } else if (this.selectedSection === DashboardSections.Marketplace) {
        /* MARKETPLACE */
        this.getInfoCardsData();
        // this.getVisitors();
        this.getMarketplaceSummaryData();
        this.getSalesData();
        this.getProductConversions();
        // this.getCampaignConversions();
        this.getMarketplaceWatchlistData();
      } else if (this.selectedSection === DashboardSections.Subscription) {
        this.getSubscriptionTopCardsData();
        this.getSubscriptionSummaryData();
        this.getSubscriptionCancellationReasonsData();
        this.getSubscriptionOfferTypeData();
        this.getSubscriptionProductData();
        this.getSubscriptionCampaignProductData();
        this.getSubscriptionBillingCycleData();
        this.getSubscriptionFrequencyData();
        this.getSubscriptionCampaignData();
        this.getSubscriptionCustomerStageData();
        this.getSubscriptionCanceledWithPendingOrderData();
      } else if (this.selectedSection === DashboardSections.Order) {
        this.getOrdersKpiCardsData();
        this.getOrdersRetentionSummaryData();
        this.getOrdersCancellationReasonsData();
        this.getOrdersMoneyCardsData();
        this.getOrdersOfferTypeData();
        this.getOrdersProductData();
        this.getOrdersCampaignProductData();
        this.getOrdersCampaignData();
        this.getOrdersCustomerStageData();
      } else if (this.selectedSection === DashboardSections.Return) {
        this.getReturnsKpiCardsData();
        this.getReturnsMoneyCardsData();
        this.getReturnsRetentionSummaryData();
        this.getReturnsOpenActivityData();
        this.getReturnsReasonsData();
        this.getReturnsProductsData();
        this.getReturnsOffersData();
        this.getReturnsAiInsightsData();
      }
    }
  }

  // The filter outlives the page, so each dashboard page sets its own section before loading.
  setSectionFromRoute() {
    const data = this.route.snapshot.data;
    const tab = this.route.snapshot.queryParamMap.get("tab");

    if (data && data.dashboardSections) {
      this.pageSections = data.dashboardSections;
    }

    let section = this.pageSections[0];
    this.pageSections.forEach((pageSection: DashboardSections) => {
      if (tab && pageSection.toLowerCase() === tab) {
        section = pageSection;
      }
    });

    this.selectedSection = section;
    const filter = this.dashboardService.getFilter();
    // Arriving from another section clears its section-specific filters, as a tab switch does.
    if (filter.section !== section) {
      this.dashboardService.setFilter({
        ...filter,
        section,
        campaign_id: null,
        product_name: null,
        offer_intent: null,
        merchant_profile_id: null,
      });
    }
  }

  openSectionPage(section: DashboardSections) {
    const page = DashboardSectionPage[section];

    if (page) {
      const queryParams = page.tab ? { tab: page.tab } : {};
      this.router.navigate([page.path], { queryParams });
    }
  }

  setAccountID() {
    this.selectedFilters = this.dashboardService.getFilter();
    this.accountService.selectedAccount$.subscribe(
      (account: any) => {
        if (account) {
          this.dashboardService.setFilter({
            ...this.selectedFilters,
            account_id: account.id,
            campaign_id: null,
            crm_id: null,
          });
        }
      },
      (error) => {
        this.alertService.error(error.message);
      }
    );
  }

  getCurrentUser() {
    this.userService
      .getCurrent()
      .pipe(takeUntil(this._destroy$))
      .subscribe((user: User) => {
        this.currentUser = user;
      });
  }

  getAccountsList() {
    this.accountService
      .list({ page: 1, page_size: config.maxPageSize })
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (data: Pager) => {
          this.accounts = data.results;
        },
        (error) => {
          this.alertService.error(error.message);
        }
      );
  }

  async ngAfterViewInit() {
    await delay(2000);
    this.loader.hide();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  private collapseNavForRetentionSections() {
    if (this.isRetentionDashboard) {
      this.sideNavService.setSideNavExpanded(false);
    }
  }

  onSectionChange(section: DashboardSections) {
    if (section === this.selectedSection) return;
    this.selectedSection = section;
    this.dashboardService.setFilter({
      ...this.selectedFilters,
      section,
      campaign_id: null,
      product_name: null,
      offer_intent: null,
      merchant_profile_id: null,
    });
    this.getSectionData();
    this.collapseNavForRetentionSections();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  getDashboardData() {
    this.dashboardService.filters$
      .pipe(takeUntil(this._destroy$))
      .subscribe((change) => {
        this.selectedFilters = change;
        this.initiateCardsLoading();
        if (this.selectedFilters.account_id) {
          if (this.selectedSection === DashboardSections.Overview) {
            Object.keys(this.overviewServicesMap).forEach((key) => {
              this.overviewServicesMap[key].setFilter(change);
              this.overviewServicesMap[key].getData();
              this.sessions.flag = true;
            });
            // The Order scope is a separate summary request, fetched only while that tab is open.
            this.overviewOrderPortalActionsService.setFilter(change);
            if (this.portalActions.scope === PortalActionScope.Order) {
              this.overviewOrderPortalActionsService.getData();
            }
            this.updateSessionFilter();
          } else if (this.selectedSection === DashboardSections.Retention) {
            Object.keys(this.retentionServicesMap).forEach((key) => {
              this.retentionServicesMap[key].setFilter(change);
              this.retentionServicesMap[key].getData();
            });
          } else if (this.selectedSection === DashboardSections.Marketplace) {
            Object.keys(this.marketplaceServicesMap).forEach((key) => {
              this.marketplaceServicesMap[key].setFilter({
                ...change,
                crm_id: null,
              });
              this.marketplaceServicesMap[key].getData();
            });
          } else if (this.selectedSection === DashboardSections.Subscription) {
            Object.keys(this.subscriptionServicesMap).forEach((key) => {
              this.subscriptionServicesMap[key].setFilter(change);
              this.subscriptionServicesMap[key].getData();
            });
          } else if (this.selectedSection === DashboardSections.Order) {
            Object.keys(this.ordersServicesMap).forEach((key) => {
              this.ordersServicesMap[key].setFilter(change);
              this.ordersServicesMap[key].getData();
            });
          } else if (this.selectedSection === DashboardSections.Return) {
            Object.keys(this.returnsServicesMap).forEach((key) => {
              this.returnsServicesMap[key].setFilter(change);
              this.returnsServicesMap[key].getData();
            });
          }
        }
      });
  }

  getSessionsData() {
    this.dashboardSessionService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((data: DashboardSessionResultsAPIResponse) => {
        if (data) {
          const sessionResults = data.session_results || {};
          const selfServiceRate = data.self_service_rate || [0, 0];
          const successfulSessions = sessionResults.Successful || 0;
          const bypassSessions = sessionResults.Bypass || 0;
          const dropoffSessions = sessionResults.Dropoffs || 0;
          const lifelineSessions = sessionResults.Lifeline || 0;

          const totalSessions =
            successfulSessions +
            bypassSessions +
            dropoffSessions +
            lifelineSessions;

          /* Stopping Loading */
          this.sessionsDoughnutData.loading = false;

          /* Info Cards Data */
          // self_service_rate is [numerator, denominator], avoiding a 0/0 divide here
          if (selfServiceRate[0] === 0 && selfServiceRate[1] === 0) {
            this.infoCards[OverviewInfo.SelfService].value = "0%";
          } else {
            this.infoCards[OverviewInfo.SelfService].value = `${(
              (selfServiceRate[0] / selfServiceRate[1]) *
              100
            ).toFixed(2)}%`;
          }
          this.infoCards[
            OverviewInfo.Sessions
          ].value = `${totalSessions.toLocaleString()}`;

          /* Sessions Table & Chart Data */
          /* CASE: No Data Returned from API */
          if (totalSessions === 0) {
            this.sessionsTableData.forEach((data) => {
              data.value = 0;
              data.percentage = "0%";
            });

            this.sessionsDoughnutData.data = [
              successfulSessions,
              bypassSessions,
              dropoffSessions,
              lifelineSessions,
            ];

            /* Chart No Record Case: true */
            this.sessionsDoughnutData.noData = true;
          } else {
            /* CASE: Data Returned from API */
            /* Chart No Record Case: false */
            this.sessionsDoughnutData.noData = false;

            /* Chart Data */
            this.sessionsDoughnutData.data = [
              successfulSessions,
              bypassSessions,
              dropoffSessions,
              lifelineSessions,
            ];

            /* Table Data */
            this.sessionsTableData[0].value = successfulSessions.toLocaleString();
            this.sessionsTableData[0].percentage =
              successfulSessions > 0
                ? `${((successfulSessions / totalSessions) * 100).toFixed(2)}%`
                : "0%";

            this.sessionsTableData[1].value = bypassSessions.toLocaleString();
            this.sessionsTableData[1].percentage =
              bypassSessions > 0
                ? `${((bypassSessions / totalSessions) * 100).toFixed(2)}%`
                : "0%";

            this.sessionsTableData[2].value = dropoffSessions.toLocaleString();
            this.sessionsTableData[2].percentage =
              dropoffSessions > 0
                ? `${((dropoffSessions / totalSessions) * 100).toFixed(2)}%`
                : "0%";

            this.sessionsTableData[3].value = lifelineSessions.toLocaleString();
            this.sessionsTableData[3].percentage =
              lifelineSessions > 0
                ? `${((lifelineSessions / totalSessions) * 100).toFixed(2)}%`
                : "0%";
          }
        }
      });
  }

  updateSessionFilter() {
    if (!this.sessions.flag) {
      return;
    }
    let filter = { started: true };

    if ("start_date" in this.selectedFilters) {
      filter["date_joined__gt"] = this.dashboardService.convertDateToUtc(
        this.selectedFilters.start_date,
        this.selectedFilters.timezone
      );
    }

    const finalizedUntil = moment.utc().subtract(sessionFinalizationHours, "hours").format("YYYY-MM-DD HH:mm:ss");
    filter["date_joined__lte"] = finalizedUntil;

    if ("end_date" in this.selectedFilters) {
      const endDate = this.dashboardService.convertDateToUtc(
        this.selectedFilters.end_date,
        this.selectedFilters.timezone
      );
      filter["date_joined__lte"] = endDate < finalizedUntil ? endDate : finalizedUntil;
    }

    if (this.selectedFilters.campaign_id) {
      filter["campaign"] = this.selectedFilters.campaign_id;
    }

    if (this.selectedFilters.crm_id) {
      filter["crm_id"] = this.selectedFilters.crm_id;
    }

    if (!this.sessions.filters.includeTestSessions) {
      filter["is_test"] = false;
    }

    if (this.selectedFilters.account_id) {
      filter["account_id"] = this.selectedFilters.account_id;
    }

    let result_filters: SessionResult[] = [];

    if (!this.sessions.filters.includeHangups) {
      result_filters.push(SessionResult.Abandoned);
    }

    if (!this.sessions.filters.includeUnknowns) {
      result_filters.push(SessionResult.Unknown);
    }

    if (result_filters.length > 0) {
      filter["latest_result__in!"] = result_filters.join(",");
    }

    this.sessions.filter = { ...filter };
    this.sessions.flag = false;
  }

  /* Session Table Props */
  onPortalActionsScopeChange(scope: PortalActionScope) {
    // Always refetch: a response for an earlier filter set may land while the tab is hidden.
    if (scope === PortalActionScope.Order && this.selectedFilters && this.selectedFilters.account_id) {
      this.portalActions.orderData = null;
      applyPortalActionsScope(this.portalActions, scope);
      this.overviewOrderPortalActionsService.getData();
    }
  }

  onSessionFilterChange() {
    const { includeTestSessions, includeHangups, includeUnknowns } = this.sessions.filters;
    this.sessions.state.includeTest = includeTestSessions;
    this.sessions.state.includeHangups = includeHangups;
    this.sessions.state.includeUnknowns = includeUnknowns;
    this.dashboardService.setFilter({
      ...this.selectedFilters,
      includeTest: includeTestSessions,
      includeHangups,
      includeUnknowns,
    });
  }

  /* ======================RETENTION=======================*/
  getMiscData() {
    this.retentionMiscDataService.data$.subscribe(
      (miscData: RetentionMiscDataAPIResponse) => {
        const {
          customers_cancelled,
          customers_saved,
          path_breakdown,
          survey_responses,
          cancel_categories,
        } = miscData;

        /* Customers Cancelled */
        this.retentionTopCards[RetentionInfoTop.CustomersLost].value =
          customers_cancelled.toLocaleString();

        /* Cancel Categories (Hidden For Now)*/
        // this.cancellationData.noData = false;
        // this.cancellationData.loading = false;
        // if (Array.isArray(cancel_categories) && cancel_categories.length > 0) {
        //   cancel_categories.forEach((i: RetentionCancelCategory) => {
        //     switch (i.cancel_reason_category) {
        //       case "Unwanted":
        //         this.assignCancelCategoryData(i, 0);
        //         break;
        //       case "Technical issues":
        //         this.assignCancelCategoryData(i, 1);
        //         break;
        //       case "Price":
        //         this.assignCancelCategoryData(i, 2);
        //         break;
        //       case "Product issue":
        //         this.assignCancelCategoryData(i, 3);
        //         break;
        //       case "Support issues":
        //         this.assignCancelCategoryData(i, 4);
        //         break;
        //       case "Shipping":
        //         this.assignCancelCategoryData(i, 5);
        //         break;
        //     }
        //     this.cancellationTableData.forEach((data, index) => {
        //       data.value = this.cancellationData.data[index].toLocaleString();
        //       if (data.percentage === null) data.percentage = "0%";
        //     });
        //     if (
        //       this.cancellationData.data.every((value: number) => value === 0)
        //     ) {
        //       this.cancellationData.noData = true;
        //     }
        //   });
        // } else {
        //   this.cancellationData.noData = true;
        //   this.cancellationTableData.forEach((data) => {
        //     data.value = 0;
        //     data.percentage = "0%";
        //   });
        // }

        /* Survey Responses */
        this.surveyResponses.data = [];
        this.surveyResponses.loading = false;
        if (survey_responses.length >= 3) {
          const responses = [];
          for (const response of survey_responses) {
            if (response.cancel_reason) {
              responses.push({
                name: response.cancel_reason,
                value: response.cancelled.toLocaleString() || 0,
              });
            }
          }
          this.surveyResponses.data = responses;
        }

        /* Path Breakdown */
        this.pathBreakdowns.data = [];
        this.pathBreakdowns.loading = false;
        if (path_breakdown.length > 0) {
          const paths = [];
          for (const path of path_breakdown) {
            paths.push({
              name: path.product_path,
              // type: "Type1",
              sessions: path.session_count.toLocaleString() || "0",
              saved: path.saved || 0,
            });
          }
          this.pathBreakdowns.data = paths;
        }
      }
    );
  }

  /* Cancel Categories hidden for now */
  // assignCancelCategoryData(i: RetentionCancelCategory, index: number) {
  //   this.cancellationData.data[index] = i.cancelled;
  //   this.cancellationTableData[index].percentage = `${i.cancelled_percentage}%`;
  // }

  getStatisticsData() {
    this.retentionStatisticsService.data$.subscribe(
      (apiData: DashboardRetentionStatisticsAPIResponse) => {
        if (!apiData) return;
        if (apiData && Object.keys(apiData).length > 0) {
          const apiResponse = apiData[0];
          this.retentionTopCards[RetentionInfoTop.RevenueSaved].value =
            "$" +
            apiResponse.save_amount.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });

          this.retentionTopCards[RetentionInfoTop.Saves].value =
            apiResponse.total_saves.toLocaleString();

          this.retentionTopCards[RetentionInfoTop.SaveRate].value =
            (apiResponse.total_save_rate * 100).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) + "%";

          this.retentionMidCards[RetentionInfoMid.OrdersSaved].value =
            apiResponse.hold_save.toLocaleString();
          this.retentionMidCards[RetentionInfoMid.OrdersCancelled].value =
            apiResponse.hold_cancel.toLocaleString();
          this.retentionMidCards[RetentionInfoMid.SubscriptionsSaved].value =
            apiResponse.subscription_save.toLocaleString();
          this.retentionMidCards[
            RetentionInfoMid.SubscriptionsCancelled
          ].value = apiResponse.subscription_cancel.toLocaleString();
        } else {
          // Set values to '0' when no data is available
          this.retentionMidCards[RetentionInfoMid.OrdersSaved].value = "0";
          this.retentionMidCards[RetentionInfoMid.OrdersCancelled].value = "0";
          this.retentionMidCards[RetentionInfoMid.SubscriptionsSaved].value =
            "0";
          this.retentionMidCards[
            RetentionInfoMid.SubscriptionsCancelled
          ].value = "0";
          this.retentionTopCards[RetentionInfoTop.RevenueSaved].value = "$0";
          this.retentionTopCards[RetentionInfoTop.Saves].value = "0";
          this.retentionTopCards[RetentionInfoTop.SaveRate].value = "0%";
        }
      }
    );
  }

  getOverviewRefundsSummary() {
    this.overviewRefundsSummaryService.data$.pipe(takeUntil(this._destroy$)).subscribe((apiData: OverviewRefundsSummaryAPIResponse) => {
      const resolveRefundsStat = this.resolvePerformanceStats[this.resolvePerformanceStatIndex.Refunds];
      const resolveRefundAmountStat = this.resolvePerformanceStats[this.resolvePerformanceStatIndex.RefundAmount];
      const resolveFullRefundAmountStat = this.resolvePerformanceStats[this.resolvePerformanceStatIndex.FullRefundAmount];

      // Null-checked too, not just undefined - an empty DRF decimal throws on .toLocaleString().
      let apiResponse: OverviewRefundsSummary = null;
      if (apiData && Array.isArray(apiData) && apiData.length > 0) {
        apiResponse = apiData[0];
      }

      let refundAmount = 0;
      if (apiResponse && apiResponse.item_refund_amount !== undefined && apiResponse.item_refund_amount !== null) {
        refundAmount = apiResponse.item_refund_amount;
      }
      let refundQuantity = 0;
      if (apiResponse && apiResponse.item_refund_quantity !== undefined && apiResponse.item_refund_quantity !== null) {
        refundQuantity = apiResponse.item_refund_quantity;
      }
      let fullRefundAmount = 0;
      if (
        apiResponse &&
        apiResponse.item_full_refund_amount !== undefined &&
        apiResponse.item_full_refund_amount !== null
      ) {
        fullRefundAmount = apiResponse.item_full_refund_amount;
      }

      // data$ replays undefined first, which would stop the loaders at $0.00.
      if (apiData) {
        resolveRefundsStat.value = refundQuantity.toLocaleString();
        resolveRefundAmountStat.value = "$" + formatMoney(refundAmount);
        resolveFullRefundAmountStat.value = "$" + formatMoney(fullRefundAmount);
      }
    });
  }

  getOverviewReturnsMoneyCardsData() {
    this.overviewReturnsMoneyCardsService.data$.pipe(takeUntil(this._destroy$)).subscribe((apiData: MoneyCardsResponse) => {
      const refundCard = returnSummaryDualCards[ReturnSummaryDualIndex.RefundAmountRate];

      let refundAmount = 0;
      let refundRate = 0;
      let refundTrend: number = null;
      if (apiData && apiData.cards && apiData.cards.length > 0) {
        apiData.cards.forEach((card: MoneyCard) => {
          if (card.key === MoneyCardKey.ReturnsRefundAmount) {
            if (card.amount !== undefined && card.amount !== null) {
              refundAmount = card.amount;
            }
            if (card.trend_pct !== undefined && card.trend_pct !== null) {
              refundTrend = card.trend_pct;
            }
          } else if (card.key === MoneyCardKey.ReturnsRefundRate && card.amount !== undefined && card.amount !== null) {
            refundRate = card.amount;
          }
        });
      }

      if (apiData) {
        refundCard.leftVal = "$" + formatMoney(refundAmount);
        refundCard.rightVal = refundRate.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "%";
        this.applyOverviewTrend(refundCard, refundTrend);

        if (refundAmount > 0 || refundRate > 0) {
          overviewSummaryHasActivity.returns = true;
        }
      }
    });
  }

  // A trend of 0 carries no meaning on a badge, so it renders as no badge at all.
  private applyOverviewTrend(card: { percentage?: number | null; is_negative?: boolean }, trendPct: number | null) {
    card.percentage = (trendPct !== null && trendPct !== 0) ? Math.abs(trendPct) : null;
    card.is_negative = (trendPct !== null && trendPct !== 0) ? trendPct < 0 : false;
  }

  private applyMarketplaceSummary(summary: CustomerSupportMarketplaceSummary) {
    const revenueCard = marketplaceSummaryInfoCards[MarketplaceSummaryIndex.Revenue];
    const aovCard = marketplaceSummaryInfoCards[MarketplaceSummaryIndex.AOV];
    const completedOrdersCard = marketplaceSummaryInfoCards[MarketplaceSummaryIndex.CompletedOrders];
    const conversionRateCard = marketplaceSummaryInfoCards[MarketplaceSummaryIndex.ConversionRate];
    const trend = summary.trend || {};

    revenueCard.value = "$" + formatMoney(summary.revenue);
    aovCard.value = "$" + formatMoney(summary.aov);
    completedOrdersCard.value = summary.completed_orders.toLocaleString();
    conversionRateCard.value = summary.conversion_rate.toLocaleString("en-US", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }) + "%";

    this.applyOverviewTrend(revenueCard, trend.revenue !== undefined ? trend.revenue : null);
    this.applyOverviewTrend(aovCard, trend.aov !== undefined ? trend.aov : null);
    this.applyOverviewTrend(completedOrdersCard, trend.completed_orders !== undefined ? trend.completed_orders : null);
    this.applyOverviewTrend(conversionRateCard, trend.conversion_rate !== undefined ? trend.conversion_rate : null);

    if (summary.completed_orders > 0 || summary.revenue > 0) {
      overviewSummaryHasActivity.marketplace = true;
    }
  }

  private findOverviewKpiCard(apiData: KpiCardsResponse, key: KpiCardKey): KpiCard {
    let found: KpiCard = null;
    if (apiData.cards && apiData.cards.length > 0) {
      found = apiData.cards.find((kpiCard: KpiCard) => kpiCard.key === key);
    }
    return found;
  }

  private applyOverviewKpiCards(apiData: KpiCardsResponse, card: OverviewDualCard) {
    const cancelledCard = this.findOverviewKpiCard(apiData, KpiCardKey.Cancelled);
    const savedCard = this.findOverviewKpiCard(apiData, KpiCardKey.Saved);
    let cancelled = 0;
    let saved = 0;

    if (cancelledCard) {
      cancelled = cancelledCard.value;
    }
    if (savedCard) {
      saved = savedCard.value;
    }

    card.leftVal = cancelled.toLocaleString();
    card.rightVal = saved.toLocaleString();

    if (cancelled > 0 || saved > 0) {
      overviewSummaryHasActivity.retention = true;
    }
  }

  getOverviewOrderKpiCardsData() {
    this.overviewOrderKpiCardsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: KpiCardsResponse) => {
        if (apiData) {
          this.overviewOrderKpiLoading = false;
          this.applyOverviewKpiCards(apiData, this.overviewDualCards[this.overviewDualCardIndex.OrderCanceled]);
        }
      });
  }

  getOverviewSubscriptionKpiCardsData() {
    this.overviewSubscriptionKpiCardsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: KpiCardsResponse) => {
        if (apiData) {
          this.overviewSubscriptionKpiLoading = false;
          this.applyOverviewKpiCards(apiData, this.overviewDualCards[this.overviewDualCardIndex.SubscrCanceled]);
        }
      });
  }

  private applyOverviewSessionCounts(overview: CustomerSupportOverview, trend: CustomerSupportOverviewTrend) {
    if (overview) {
      const allSessionsCard = this.overviewDualCards[this.overviewDualCardIndex.AllSessions];
      const allStartedSessions = overview.all_started_sessions || 0;
      const startedSessions = overview.started_sessions || 0;
      allSessionsCard.leftVal = allStartedSessions.toLocaleString();
      allSessionsCard.rightVal = startedSessions.toLocaleString();

      if (allStartedSessions > 0 || startedSessions > 0) {
        overviewSummaryHasActivity.retention = true;
      }

      this.applyOverviewTrend(allSessionsCard, trend && trend.all_started_sessions !== undefined ? trend.all_started_sessions : null);

      const phoneCard = supportSummaryInfoCards[SupportSummaryIndex.Phone];
      const emailCard = supportSummaryInfoCards[SupportSummaryIndex.Email];
      const directLinksCard = supportSummaryInfoCards[SupportSummaryIndex.DirectLinks];
      const socialCard = supportSummaryInfoCards[SupportSummaryIndex.Social];
      phoneCard.value = (overview.phone_sessions || 0).toLocaleString();
      emailCard.value = (overview.email_support || 0).toLocaleString();
      directLinksCard.value = (overview.direct_link_sessions || 0).toLocaleString();
      socialCard.value = (overview.social_sessions || 0).toLocaleString();
      this.applyOverviewTrend(phoneCard, trend && trend.phone_sessions !== undefined ? trend.phone_sessions : null);
      this.applyOverviewTrend(emailCard, trend && trend.email_support !== undefined ? trend.email_support : null);
      this.applyOverviewTrend(
        directLinksCard,
        trend && trend.direct_link_sessions !== undefined ? trend.direct_link_sessions : null
      );
      this.applyOverviewTrend(socialCard, trend && trend.social_sessions !== undefined ? trend.social_sessions : null);
    }
  }

  getOverviewTopIntentsData() {
    this.overviewTopIntentsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: CustomerSupportSummaryAPIResponse) => {
        if (apiData) {
          const overview = (apiData as CustomerSupportSummary).overview;
          const trend = (apiData as CustomerSupportSummary).overview_trend;

          if (this.selectedSection === DashboardSections.Overview) {
            this.applyOverviewSessionCounts(overview, trend);
          }

          applyTopIntents((apiData as CustomerSupportSummary).top_intents, overview);

          const topFaqsResponse = (apiData as CustomerSupportSummary).top_faqs;
          faqs.data = [];
          faqs.loading = false;

          if (topFaqsResponse && !topFaqsResponse.pending && topFaqsResponse.results && topFaqsResponse.results.length > 0) {
            faqs.data = topFaqsResponse.results.map((faq: CustomerSupportTopFaq) => ({
              name: faq.question,
              sessions: faq.session_count.toLocaleString(),
              pctSupport: faq.share.toFixed(1) + "%",
            }));
          }

          faqs.noData = faqs.data.length === 0;

          const marketplaceSummary = (apiData as CustomerSupportSummary).marketplace_summary;
          if (marketplaceSummary) {
            this.applyMarketplaceSummary(marketplaceSummary);
          }
        }
      });
  }

  getOverviewPortalMomentsData() {
    this.overviewPortalMomentsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: CustomerSupportSummaryAPIResponse) => {
        if (apiData) {
          const moments = (apiData as CustomerSupportSummary).portal_moments;
          this.portalMoments.data = [];
          this.portalMoments.loading = false;

          if (moments && moments.length > 0) {
            this.portalMoments.data = moments.map((moment: CustomerSupportPortalMoment) => ({
              name: moment.moment_name,
              sessions: moment.session_count.toLocaleString(),
              sessionPct: moment.share.toFixed(1) + "%",
            }));
          }

          this.portalMoments.noData = this.portalMoments.data.length === 0;

          const portalActionsResponse = (apiData as CustomerSupportSummary).portal_actions;
          this.portalActions.subscriptionData = [];

          if (
            portalActionsResponse &&
            !portalActionsResponse.pending &&
            portalActionsResponse.results &&
            portalActionsResponse.results.length > 0
          ) {
            this.portalActions.subscriptionData = mapPortalActionRows(portalActionsResponse.results);
          }

          applyPortalActionsScope(this.portalActions, this.portalActions.scope);
        }
      });
  }

  getOverviewOrderPortalActionsData() {
    this.overviewOrderPortalActionsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: CustomerSupportSummaryAPIResponse) => {
        if (apiData) {
          const portalActionsResponse = (apiData as CustomerSupportSummary).portal_actions;
          this.portalActions.orderData = [];

          if (
            portalActionsResponse &&
            !portalActionsResponse.pending &&
            portalActionsResponse.results &&
            portalActionsResponse.results.length > 0
          ) {
            this.portalActions.orderData = mapPortalActionRows(portalActionsResponse.results);
          }

          applyPortalActionsScope(this.portalActions, this.portalActions.scope);
        }
      });
  }

  // Sums both money_cards' revenue_saved; trend rebuilt from both periods, not either side's.
  private applyOverviewRevenueSaved() {
    const sources: MoneyCard[] = [];
    if (this.overviewOrderSavedRevenue) {
      sources.push(this.overviewOrderSavedRevenue);
    }
    if (this.overviewSubscriptionSavedRevenue) {
      sources.push(this.overviewSubscriptionSavedRevenue);
    }

    if (sources.length > 0) {
      const revenueCard = this.overviewTopSingleCards[0];
      let total = 0;
      let previousTotal = 0;
      let previousKnown = true;

      sources.forEach((source: MoneyCard) => {
        total += source.amount;
        // prev = value / (1 + trend/100); a null trend means prev was 0, -100% leaves it unrecoverable.
        if (source.trend_pct !== null && source.trend_pct !== undefined) {
          const factor = 1 + source.trend_pct / 100;
          if (factor === 0) {
            previousKnown = false;
          } else {
            previousTotal += source.amount / factor;
          }
        }
      });

      revenueCard.value = "$" + formatMoney(total);

      if (total > 0) {
        overviewSummaryHasActivity.retention = true;
      }

      let trendPct: number = null;
      if (previousKnown && previousTotal > 0) {
        // One decimal, matching the engine's trend_pct.
        trendPct = Math.round(((total - previousTotal) / previousTotal) * 1000) / 10;
      }
      this.applyOverviewTrend(revenueCard, trendPct);
    }
  }

  getOverviewReturnsKpiCardsData() {
    this.overviewReturnsKpiCardsService.data$.pipe(takeUntil(this._destroy$)).subscribe((apiData: KpiCardsResponse) => {
      const returnRequestsStat = returnSummaryInfoCards[ReturnSummaryIndex.ReturnRequests];
      const deflectedStat = returnSummaryInfoCards[ReturnSummaryIndex.Deflected];
      const returnsCard = returnSummaryDualCards[ReturnSummaryDualIndex.ReturnsCompleted];
      let cancelRequests = 0;
      let saved = 0;
      let abandoned = 0;

      // data$ replays undefined first, which would stop the loader at 0.
      if (apiData) {
        if (apiData.cards && apiData.cards.length > 0) {
          apiData.cards.forEach((card: KpiCard) => {
            if (card.key === KpiCardKey.CancelRequests) {
              cancelRequests = card.value;
            } else if (card.key === KpiCardKey.Saved) {
              saved = card.value;
            } else if (card.key === KpiCardKey.Abandoned) {
              abandoned = card.value;
            }
          });
        }

        returnRequestsStat.value = cancelRequests.toLocaleString();
        deflectedStat.value = saved.toLocaleString();
        returnsCard.rightVal = this.getReturnsCompletedCount(cancelRequests, saved, abandoned).toLocaleString();

        if (cancelRequests > 0 || saved > 0 || abandoned > 0) {
          overviewSummaryHasActivity.returns = true;
        }
      }
    });
  }

  getOverviewReturnsOpenActivityData() {
    this.overviewReturnsOpenActivityService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: OpenReturnActivityResponse) => {
        const returnsCard = returnSummaryDualCards[ReturnSummaryDualIndex.ReturnsCompleted];
        if (apiData) {
          const pendingReturns = apiData.pending_returns || 0;
          returnsCard.leftVal = pendingReturns.toLocaleString();

          if (pendingReturns > 0) {
            overviewSummaryHasActivity.returns = true;
          }
        }
      });
  }

  // cancel_requests = saved + cancelled + abandoned, so completed is the remainder.
  getReturnsCompletedCount(cancelRequests: number, saved: number, abandoned: number): number {
    return Math.max(cancelRequests - saved - abandoned, 0);
  }

  setOverviewCompareSubtitle() {
    const allSessionsCard = this.overviewDualCards[this.overviewDualCardIndex.AllSessions];
    let subtitle = "--";
    if (this.selectedFilters && this.selectedFilters.compare_start_date && this.selectedFilters.compare_end_date) {
      const start = moment(this.selectedFilters.compare_start_date).format("MMM D");
      const end = moment(this.selectedFilters.compare_end_date).format("MMM D");
      subtitle = `Vs ${start} - ${end}`;
    }
    allSessionsCard.subtitle = subtitle;
    supportSummaryInfoCards.forEach((card) => (card.subtitle = subtitle));
    marketplaceSummaryInfoCards.forEach((card) => (card.subtitle = subtitle));
    returnSummaryInfoCards.forEach((card) => (card.subtitle = subtitle));
    returnSummaryDualCards.forEach((card) => (card.subtitle = subtitle));
  }

  // Own service so Overview's and Orders' filters can't overwrite each other.
  mapOverviewMoneyCardsData(data$: Observable<MoneyCardsResponse>, cardIndex: OverviewDualCardIndex) {
    data$.pipe(takeUntil(this._destroy$)).subscribe((apiData: MoneyCardsResponse) => {
      if (apiData) {
        const target = this.overviewDualCards[cardIndex];
        target.subtitleLoading = false;
        let totalRefunds = 0;
        let savedRevenue: MoneyCard = null;
        if (apiData.cards && apiData.cards.length > 0) {
          apiData.cards.forEach((card: MoneyCard) => {
            if (card.key === MoneyCardKey.TotalRefunds && card.amount !== undefined && card.amount !== null) {
              totalRefunds = card.amount;
            } else if (card.key === MoneyCardKey.RevenueSaved) {
              savedRevenue = card;
            }
          });
        }
        target.subtitle = refundAmountPrefix + "$" + formatMoney(totalRefunds);

        if (cardIndex === this.overviewDualCardIndex.OrderCanceled) {
          this.overviewOrderSavedRevenue = savedRevenue;
        } else if (cardIndex === this.overviewDualCardIndex.SubscrCanceled) {
          this.overviewSubscriptionSavedRevenue = savedRevenue;
        }
        this.applyOverviewRevenueSaved();
      }
    });
  }

  getOverviewOrderMoneyCardsData() {
    this.mapOverviewMoneyCardsData(
      this.overviewOrderMoneyCardsService.data$,
      this.overviewDualCardIndex.OrderCanceled,
    );
  }

  getOverviewSubscriptionMoneyCardsData() {
    this.mapOverviewMoneyCardsData(
      this.overviewSubscriptionMoneyCardsService.data$,
      this.overviewDualCardIndex.SubscrCanceled,
    );
  }

  mapOverviewCancellationReasonsData(data$: Observable<TopCancellationReasonsResponse>, target: OverviewCardState<GroupedChartRow>) {
    data$.pipe(takeUntil(this._destroy$)).subscribe((apiData: TopCancellationReasonsResponse) => {
      if (apiData) {
        target.data = [];
        if (apiData.results && apiData.results.length > 0) {
          target.data = apiData.results.map((item: CancellationReasonRow) => ({
            name: item.reason,
            requests: item.requests,
            series: [
              { name: RetentionSegment.Saved, value: item.saved },
              { name: RetentionSegment.Cancelled, value: item.cancelled },
            ],
          }));
        }
        target.noData = target.data.length === 0;
        target.loading = false;
      }
    });
  }

  getOverviewOrderCancellationReasonsData() {
    this.mapOverviewCancellationReasonsData(
      this.overviewOrderCancellationReasonsService.data$,
      this.topOrderCancellationReasons
    );
  }

  getOverviewSubscriptionCancellationReasonsData() {
    this.mapOverviewCancellationReasonsData(
      this.overviewSubscriptionCancellationReasonsService.data$,
      this.topSubscriptionCancellationReasons
    );
  }

  getOverviewReturnCancellationReasonsData() {
    this.mapOverviewCancellationReasonsData(this.overviewReturnCancellationReasonsService.data$, this.topReturnReasons);
  }

  getRetentionSummary() {
    this.retentionSummaryService.data$.subscribe((summary) => {
      if (!summary) return;
      this.summaryData.noData = false;
      this.summaryData.loading = false;

      if (Array.isArray(summary) && summary.length > 0) {
        summary.forEach((element: RetentionSummaryData) => {
          this.summaryData.data[0] = element.total_saves || 0;
          this.summaryData.data[1] = element.retracted_save || 0;
          this.summaryData.data[2] = element.dropoffs || 0;
          this.summaryData.data[3] = element.return_quantity || 0;
          this.summaryData.data[4] = element.cancelled || 0;

          const totalSessions = this.summaryData.data
            .slice(0, 5)
            .reduce((acc, val) => acc + val, 0);
          this.summaryData.total = totalSessions.toLocaleString();

          this.summaryTableData[0].percentage = `${(
            (this.summaryData.data[0] / totalSessions) *
            100
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}%`;

          this.summaryTableData[1].percentage = `${(
            (this.summaryData.data[1] / totalSessions) *
            100
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}%`;

          this.summaryTableData[2].percentage = `${(
            (this.summaryData.data[2] / totalSessions) *
            100
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}%`;

          this.summaryTableData[3].percentage = `${(
            (this.summaryData.data[3] / totalSessions) *
            100
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}%`;

          this.summaryTableData[4].percentage = `${(
            (this.summaryData.data[4] / totalSessions) *
            100
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}%`;

          this.summaryTableData.forEach((data, index) => {
            data.value = this.summaryData.data[index].toLocaleString();
            if (data.percentage === null || data.percentage === "NaN%")
              data.percentage = "0%";
          });

          if (this.summaryData.data.every((value: number) => value === 0)) {
            this.summaryData.noData = true;
          }
        });
      } else {
        this.summaryData.noData = true;
        this.summaryTableData.forEach((data) => {
          data.value = 0;
          data.percentage = "0%";
        });
      }
    });
  }

  getDownsellData() {
    this.retentionDownsellService.data$.subscribe(
      (downsell: RetentionDownsellAPIResponse) => {
        if (!downsell) return;
        this.downsells.data = [];
        this.downsells.loading = false;

        if (Array.isArray(downsell) && downsell.length > 1)
          downsell.forEach((i: RetentionDownsellData) => {
            const downsellData: DefaultTableRecord = {
              name: i.step_category,
              value: `${(i.downsell_take_rate * 100).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}%`,
            };

            if (i.diff_percentage) {
              if (i.diff_percentage < 0) {
                downsellData.is_negative = true;
              }
              downsellData.percentage = Math.abs(i.diff_percentage);
            }

            this.downsells.data.push(downsellData);
          });
      }
    );
  }

  getDeflectionData() {
    this.retentionDeflectionDataService.data$.subscribe(
      (deflection: DashboardRetentionDeflectionDataAPIResponse) => {
        if (!deflection) return;
        this.deflection.noData = false;
        this.deflection.loading = false;

        if (Array.isArray(deflection) && deflection.length > 0) {
          deflection.forEach((i: RetentionDeflectionData) => {
            switch (i.key) {
              case "total_saves":
                this.assignDeflectionData(i, 0);
                break;
              case "retracted_save":
                this.assignDeflectionData(i, 1);
                break;
              case "deflected_cancel":
                this.assignDeflectionData(i, 2);
                break;
              case "deflected_rma":
                this.assignDeflectionData(i, 3);
                break;
              case "return_quantity":
                this.assignDeflectionData(i, 4);
                break;
              case "cancelled":
                this.assignDeflectionData(i, 5);
                break;
            }

            this.deflection.data.forEach((deflection) => {
              if (!deflection.value) deflection.value = 0;
            });
          });
        } else {
          this.deflection.data.forEach((deflection) => {
            deflection.value = 0;
          });
          this.deflection.noData = true;
        }
      }
    );
  }

  assignDeflectionData(i: RetentionDeflectionData, index: number) {
    this.deflection.data[index].value = i.count.toLocaleString() || "0";
    if (i.diff_percentage) {
      if (i.diff_percentage < 0) {
        this.deflection.data[index].is_negative = true;
      }
      this.deflection.data[index].percentage = Math.abs(i.diff_percentage);
    }
  }

  getWatchlistData() {
    this.retentionWatchlistService.data$.subscribe(
      (watchlist: DashboardRetentionWatchlistAPIResponse) => {
        if (!watchlist) return;

        if (Array.isArray(watchlist) && watchlist.length > 0) {
          watchlist.forEach((i: RetentionWatchlist) => {
            switch (i.reason) {
              case "Dispute Risk":
                this.assignWatchlistData(
                  i,
                  RetentionWatchlistFields.DisputeRisk
                );
                break;
              case "Cancel Dropoff":
                this.assignWatchlistData(
                  i,
                  RetentionWatchlistFields.CancelDropOff
                );
                break;
              case "Return Dropoff":
                this.assignWatchlistData(
                  i,
                  RetentionWatchlistFields.ReturnDropOff
                );
                break;
              case "Deflected Customer":
                this.assignWatchlistData(
                  i,
                  RetentionWatchlistFields.DeflectedCustomers
                );
                break;
              case "Pause Subscription":
                this.assignWatchlistData(
                  i,
                  RetentionWatchlistFields.PausedSubscriptions
                );
                break;
              case "Session Error":
                this.assignWatchlistData(
                  i,
                  RetentionWatchlistFields.SessionErrors
                );
                break;
            }

            this.watchlist.data.forEach((watchlist) => {
              if (!watchlist.value) watchlist.value = 0;
            });
          });

          // Calculate the sum of values in watchlistData
          this.watchlist.total = this.watchlist.data
            .reduce((total, item) => {
              const itemValue = parseFloat(item.value);
              if (!isNaN(itemValue)) {
                return total + itemValue;
              }
              return total;
            }, 0)
            .toLocaleString();
        } else {
          this.watchlist.data.forEach((watchlist) => {
            watchlist.value = 0;
          });
          this.watchlist.total = "0";
        }

        // Update the loading state
        this.watchlist.loading = false;
      }
    );
  }

  assignWatchlistData(i: RetentionWatchlist, index: number) {
    this.watchlist.data[index].value = i.count.toLocaleString() || "0";
    if (i.trend) {
      if (i.trend < 0) {
        this.watchlist.data[index].is_negative = true;
      }
      this.watchlist.data[index].percentage = Math.abs(i.trend);
    }
  }

  /* ======================MARKETPLACE=======================*/

  getInfoCardsData() {
    this.marketplaceTopCardsService.data$.subscribe(
      (apiData: DashboardMarketplaceTopCardsAPIResponse) => {
        if (!apiData) return;

        const data = apiData as MarketplaceTopCards;

        if (data && Object.keys(data).length > 0) {
          const revenue =
            "$" +
            data.total_revenue.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          const completedOrders = data.total_checked_outs.toLocaleString();
          const aov =
            "$" +
            data.average_order_value.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          const conversionRate =
            (data.conversion_based_on_visits * 100).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) + "%";

          this.marketplaceInfoCardsData[MarketplaceInfo.Revenue].value = revenue;
          this.marketplaceInfoCardsData[MarketplaceInfo.CompletedOrders].value = completedOrders;
          this.marketplaceInfoCardsData[MarketplaceInfo.AverageOrderValue].value = aov;
          this.marketplaceInfoCardsData[MarketplaceInfo.ConversionRate].value = conversionRate;
        } else {
          this.marketplaceInfoCardsData[MarketplaceInfo.Revenue].value = "0";
          this.marketplaceInfoCardsData[MarketplaceInfo.CompletedOrders].value = "0";
          this.marketplaceInfoCardsData[MarketplaceInfo.AverageOrderValue].value = "0";
          this.marketplaceInfoCardsData[MarketplaceInfo.ConversionRate].value = "0";
        }
      }
    );
  }

  getVisitors() {
    this.marketplaceTotalVisitorsService.data$.subscribe(
      (request: DashboardMarketplaceTotalVisitorsAPIResponse) => {
        if (!request) return;
        this.visitors.data = [];
        this.visitors.loading = false;
        this.visitors.noData = false;
        this.visitors.total = "0";
        let total = 0;

        if (Array.isArray(request) && request.length > 0) {
          const series = [];
          request.forEach((visitor: MarketplaceVisitor) => {
            const visitorData = {
              name: moment(visitor.created)
                .tz(this.selectedFilters.timezone)
                .format("hh:mm A"),
              value: visitor.total_marketplace_views,
            };

            total = total + visitorData.value;
            series.push(visitorData);
          });
          this.visitors.total = total.toLocaleString();
          this.visitors.data = [
            {
              name: "Visitors",
              series: series,
            },
          ];
        } else {
          this.visitors.noData = true;
        }
      }
    );
  }

  getMarketplaceSummaryData() {
    this.marketplaceSummaryService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((data: DashboardMarketplaceSummaryAPIResponse) => {
        if (!data) return;

        this.marketplaceDoughnutData.loading = false;
        this.marketplaceDoughnutData.noData = false;

        if (isObjectEmpty(data)) {
          this.marketplaceDoughnutData.noData = true;
          return;
        }

        const marketplaceSummary = data as MarketplaceSummary;

        this.marketplaceDoughnutData.data = [
          marketplaceSummary.total_checked_outs,
          marketplaceSummary.total_cart_abandoned,
          marketplaceSummary.total_card_declined,
        ];

        this.marketplaceDoughnutData.total = (
          marketplaceSummary.total_checked_outs +
          marketplaceSummary.total_cart_abandoned +
          marketplaceSummary.total_card_declined
        ).toLocaleString();

        const totalSessions = +this.marketplaceDoughnutData.total;

        this.marketplaceTableData[0].value =
          marketplaceSummary.total_checked_outs.toLocaleString();
        this.marketplaceTableData[0].percentage = `${(
          (marketplaceSummary.total_checked_outs / totalSessions) *
          100
        ).toFixed(2)}%`;

        this.marketplaceTableData[1].value =
          marketplaceSummary.total_cart_abandoned.toLocaleString();
        this.marketplaceTableData[1].percentage = `${(
          (marketplaceSummary.total_cart_abandoned / totalSessions) *
          100
        ).toFixed(2)}%`;

        this.marketplaceTableData[2].value =
          marketplaceSummary.total_card_declined.toLocaleString();
        this.marketplaceTableData[2].percentage = `${(
          (marketplaceSummary.total_card_declined / totalSessions) *
          100
        ).toFixed(2)}%`;
      });
  }

  getSalesData() {
    this.marketplaceSalesService.data$.subscribe(
      (request: DashboardMarketplaceSalesAPIResponse) => {
        if (!request) return;
        this.saleResponses.data = [];
        this.saleResponses.loading = false;

        if (request && Object.keys(request).length >= 3) {
          const responsesArray = [];
          for (const key in request) {
            if (request.hasOwnProperty(key)) {
              const response = request[key];
              const name = response.tracking_source;

              if (name !== null) {
                const modifiedName =
                  name.charAt(0).toUpperCase() +
                  name.slice(1).replace(/-/g, " ");
                responsesArray.push({
                  name: modifiedName,
                  value: response.total_sale || 0,
                });
              }
            }
          }
          this.saleResponses.data = responsesArray;
        }
      }
    );
  }

  getProductConversions() {
    this.marketplaceProductConversionsService.data$.subscribe(
      (request: DashboardMarketplaceProductConversionsAPIResponse) => {
        if (!request) return;
        this.productConversions.data = [];
        this.productConversions.loading = false;

        if (Array.isArray(request) && request.length > 0) {
          request.forEach((product: MarketplaceProductConversion) => {
            const productConversionData: DefaultTableRecord = {
              name: product.product_name.split(" (")[0],
              visitors: product.total_views.toLocaleString(),
              sales: product.total_checked_outs.toLocaleString(),
              revenue: "$" + product.total_revenue.toLocaleString(),
              value: `${(product.conversion_based_on_visits * 100).toFixed(
                2
              )}%`,
            };

            if (product.trend < 0) {
              productConversionData.is_negative = true;
            }
            productConversionData.percentage = Math.abs(product.trend);

            this.productConversions.data.push(productConversionData);
          });
        }
      }
    );
  }

  getCampaignConversions() {
    this.marketplaceCampaignService.data$.subscribe(
      (request: DashboardMarketplaceCampaignAPIResponse) => {
        if (!request) return;
        this.campaignConversions.data = [];
        this.campaignConversions.loading = false;

        if (Array.isArray(request) && request.length > 0) {
          request.forEach((campaign: MarketplaceCampaign) => {
            const campaignConversionData: DefaultTableRecord = {
              name: campaign.crm_campaign_name,
              value: `${(campaign.conversion_based_on_visits * 100).toFixed(
                2
              )}%`,
            };

            if (campaign.trend < 0) {
              campaignConversionData.is_negative = true;
            }
            campaignConversionData.percentage = Math.abs(campaign.trend);

            this.campaignConversions.data.push(campaignConversionData);
          });
        }
      }
    );
  }

  getMarketplaceWatchlistData() {
    this.marketplaceWatchlistService.data$.subscribe(
      (apiResponse: DashboardMarketplaceWatchlist) => {
        if (!apiResponse) return;
        this.activeWatchlists.loading = false;
        this.activeWatchlists.noData = false;

        if (apiResponse && Object.keys(apiResponse).length > 0) {
          this.activeWatchlists.data[0].value =
            apiResponse.total_cart_abandoned.toLocaleString();
          this.activeWatchlists.data[0].percentage =
            apiResponse.total_cart_abandoned_trend;
          this.activeWatchlists.data[1].value =
            apiResponse.total_card_declined.toLocaleString();
          this.activeWatchlists.data[1].percentage =
            apiResponse.total_card_declined_trend;
          this.activeWatchlists.data[2].value =
            apiResponse.in_cart.toLocaleString();
          this.activeWatchlists.data[2].percentage = apiResponse.in_cart_trend;

          if (apiResponse.total_cart_abandoned_trend < 0) {
            this.activeWatchlists.data[0].percentage = parseFloat(
              apiResponse.total_cart_abandoned_trend.toString().slice(1)
            );
            this.activeWatchlists.data[0].is_negative = true;
          }

          if (apiResponse.total_card_declined_trend < 0) {
            this.activeWatchlists.data[1].percentage = parseFloat(
              apiResponse.total_card_declined_trend.toString().slice(1)
            );
            this.activeWatchlists.data[1].is_negative = true;
          }

          if (apiResponse.in_cart_trend < 0) {
            this.activeWatchlists.data[2].percentage = parseFloat(
              apiResponse.in_cart_trend.toString().slice(1)
            );
            this.activeWatchlists.data[2].is_negative = true;
          }

          this.activeWatchlists.total = (
            apiResponse.in_cart +
            apiResponse.total_card_declined +
            apiResponse.total_cart_abandoned
          ).toLocaleString();
        } else {
          this.activeWatchlists.noData = true;
          this.activeWatchlists.total = "0";
        }
      }
    );
  }

  /* Loading Methods */
  initiateCardsLoading() {
    /* OVERVIEW */
    if (this.selectedSection === DashboardSections.Overview) {
      resetOverviewSummaryActivity();
      this.infoCards.forEach((card) => (card.value = ""));
      this.topOrderCancellationReasons.loading = true;
      this.topSubscriptionCancellationReasons.loading = true;
      this.topReturnReasons.loading = true;
      topIntentsDoughnutData.loading = true;
      this.portalMoments.loading = true;
      faqs.loading = true;
      this.portalActions.loading = true;
      this.portalActions.subscriptionData = null;
      this.portalActions.orderData = null;

      // Real-endpoint entries only - blank on every filter change, not just construction.
      this.overviewOrderKpiLoading = true;
      this.overviewSubscriptionKpiLoading = true;
      this.overviewDualCards[this.overviewDualCardIndex.AllSessions].leftVal = "--";
      this.overviewDualCards[this.overviewDualCardIndex.AllSessions].rightVal = "--";
      this.overviewOrderSavedRevenue = null;
      this.overviewSubscriptionSavedRevenue = null;
      this.overviewTopSingleCards[0].value = "--";
      this.overviewTopSingleCards[0].percentage = null;
      this.setOverviewCompareSubtitle();
      this.overviewDualCards[this.overviewDualCardIndex.OrderCanceled].subtitleLoading = true;
      this.overviewDualCards[this.overviewDualCardIndex.SubscrCanceled].subtitleLoading = true;
      this.overviewDualCards.forEach((card) => {
        card.percentage = null;
        card.is_negative = false;
      });
      // stat-row-card spins on an empty value.
      returnSummaryInfoCards[ReturnSummaryIndex.ReturnRequests].value = "";
      returnSummaryInfoCards[ReturnSummaryIndex.Deflected].value = "";
      returnSummaryDualCards[ReturnSummaryDualIndex.ReturnsCompleted].leftVal = "";
      returnSummaryDualCards[ReturnSummaryDualIndex.ReturnsCompleted].rightVal = "";
      returnSummaryDualCards[ReturnSummaryDualIndex.RefundAmountRate].leftVal = "";
      returnSummaryDualCards[ReturnSummaryDualIndex.RefundAmountRate].rightVal = "";
      this.resolvePerformanceStats[this.resolvePerformanceStatIndex.Refunds].value = "";
      this.resolvePerformanceStats[this.resolvePerformanceStatIndex.RefundAmount].value = "";
      this.resolvePerformanceStats[this.resolvePerformanceStatIndex.FullRefundAmount].value = "";
      marketplaceSummaryInfoCards.forEach((card) => (card.value = ""));
      supportSummaryInfoCards[SupportSummaryIndex.Phone].value = "";
      supportSummaryInfoCards[SupportSummaryIndex.Email].value = "";
      supportSummaryInfoCards[SupportSummaryIndex.DirectLinks].value = "";
      supportSummaryInfoCards[SupportSummaryIndex.Social].value = "";

      this.sessionsDoughnutData.noData = false;
      this.sessionsDoughnutData.loading = true;
      this.sessionsTableData.forEach((session) => {
        session.value = null;
        session.percentage = null;
      });
    }

    /* RETENTION */
    if (this.selectedSection === DashboardSections.Retention) {
      this.retentionTopCards.forEach((card) => (card.value = ""));
      this.retentionMidCards.forEach((card) => (card.value = ""));
      this.deflection.data.forEach((data) => {
        data.value = 0;
        data.percentage = null;
      });

      this.cancellationData.data = [0, 0, 0, 0, 0, 0];
      this.summaryData.data = [0, 0, 0, 0, 0, 0];

      this.summaryTableData.forEach((data) => {
        data.value = 0;
        data.percentage = "0%";
      });

      this.cancellationTableData.forEach((data) => {
        data.value = 0;
        data.percentage = "0%";
      });

      this.surveyResponses.loading = true;
      this.watchlist.loading = true;
      this.deflection.loading = true;
      this.pathBreakdowns.loading = true;
      this.downsells.loading = true;
      this.summaryData.loading = true;
      this.cancellationData.loading = true;

      this.cancellationData.noData = false;
      this.deflection.noData = false;
      this.summaryData.noData = false;
    }

    /* MARKETPLACE */
    if (this.selectedSection === DashboardSections.Marketplace) {
      this.marketplaceInfoCardsData.forEach((card) => (card.value = ""));
      this.saleResponses.loading = true;
      this.visitors.loading = true;
      this.marketplaceDoughnutData.loading = true;
      this.productConversions.loading = true;
      this.campaignConversions.loading = true;
      this.activeWatchlists.loading = true;
    }

    /* SUBSCRIPTION */
    if (this.selectedSection === DashboardSections.Subscription) {
      this.kpiCardsLoading = true;
      this.subscriptionTopCardsData.forEach((card) => { card.value = ''; });
      this.subscriptionDoughnutData.loading = true;
      this.subscriptionDoughnutData.noData = false;
      this.subscriptionCancellationReasons.loading = true;
      this.subscriptionCancellationReasons.noData = false;
      this.subscriptionOfferTypeData.loading = true;
      this.subscriptionOfferTypeData.noData = false;
      this.subscriptionProductData.loading = true;
      this.subscriptionProductData.noData = false;
      this.subscriptionProductData.baseData = null;
      this.subscriptionProductData.campaignData = null;
      this.subscriptionBillingCycleData.loading = true;
      this.subscriptionBillingCycleData.noData = false;
      this.subscriptionFrequencyData.loading = true;
      this.subscriptionFrequencyData.noData = false;
      this.subscriptionCampaignData.loading = true;
      this.subscriptionCampaignData.noData = false;
      this.subscriptionCustomerStageData.loading = true;
      this.subscriptionCustomerStageData.noData = false;
      this.canceledWithPendingOrderData.show = false;
      this.canceledWithPendingOrderData.loading = true;
    }

    /* ORDERS */
    if (this.selectedSection === DashboardSections.Order) {
      this.kpiCardsLoading = true;
      this.ordersTopCardsData.forEach((card) => { card.value = ''; });
      this.ordersDoughnutData.loading = true;
      this.ordersDoughnutData.noData = false;
      this.ordersCancellationReasons.loading = true;
      this.ordersCancellationReasons.noData = false;
      this.ordersOfferTypeData.loading = true;
      this.ordersOfferTypeData.noData = false;
      this.ordersProductData.loading = true;
      this.ordersProductData.noData = false;
      this.ordersProductData.baseData = null;
      this.ordersProductData.campaignData = null;
      this.ordersCampaignData.loading = true;
      this.ordersCampaignData.noData = false;
      this.ordersCustomerStageData.loading = true;
      this.ordersCustomerStageData.noData = false;
      ordersBillingState.loading = true;
    }

    /* RETURNS */
    if (this.selectedSection === DashboardSections.Return) {
      this.kpiCardsLoading = true;
      this.returnsTopCards.forEach((card) => {
        card.value = '--';
        card.subMetrics.forEach((metric) => { metric.value = '--'; });
      });
      this.returnsMoneyCardsLoading = true;
      this.returnsOutcomesData.loading = true;
      this.returnsOutcomesData.noData = false;
      this.returnsActivityLoading = true;
      this.returnsActivityStats.forEach((stat) => {
        stat.count = '--';
        stat.value = '--';
      });
      this.returnsReasons.loading = true;
      this.returnsReasons.noData = false;
      this.returnsProducts.loading = true;
      this.returnsProducts.noData = false;
      this.returnsOffers.loading = true;
      this.returnsOffers.noData = false;
      this.returnsAiInsights.loading = true;
      this.returnsAiInsights.noData = false;
    }
  }

  onDownloadReportClick() {
    const isBlocked =
      this.isReportDownloading ||
      (this.isOverviewSection && this.isOverviewReportDataLoading) ||
      (this.isReturnsSection && this.isReturnsReportDataLoading) ||
      (this.isOrdersSection && this.isOrdersReportDataLoading) ||
      (this.isSubscriptionSection && this.isSubscriptionReportDataLoading);
    if (!isBlocked) {
      this.downloadReport();
    }
  }

  // Only after save - unmounting earlier kills page 2 mid-capture.
  finishReportDownload() {
    this.viewReport = null;
    this.loader.hide();
    this.isReportDownloading = false;
  }

  failReportDownload() {
    this.alertService.error("Could not generate the report. Please try again.");
    this.finishReportDownload();
  }

  async downloadReport() {
    this.isReportDownloading = true;
    this.loader.show("white", "Generating your report");
    this.viewReport = this.selectedSection;
    await delay(1500);

    try {
      const filters = this.dashboardService.getFilter();
      const brandName = this.accounts.find(
        (account) => account.id === +filters.account_id
      ).name;

      const headerHeight = pdfReportHeaderHeightIn;
      const pageCenterX = pdfReportPageWidthIn / 2;

      const PDF = new jsPDF({
        unit: "in",
        format: [pdfReportPageWidthIn, pdfReportPageHeightIn],
      });

      // Draw header background
      PDF.setFillColor(240, 240, 240); // Background color
      PDF.rect(0, 0, pdfReportPageWidthIn, headerHeight, "F");

      // Draw image
      const img = new Image();
      img.src = "/assets/img/report-header.png";
      const imgWidth = pdfReportPageWidthIn; // Set the image width to match document width
      const imgX = 0; // Image starts from the left
      PDF.addImage(img, "JPEG", imgX, 0, imgWidth, headerHeight);

      // Draw text
      const headingY = headerHeight / 2;
      const reportTypeY = headerHeight / 2 + 0.5;
      const dateY = headerHeight / 2 + 0.85;

      // Scale long account names down to fit between the logo and the circle.
      const brandMaxWidth = 6.6;
      const brandBaseSize = 24;
      const brandMinSize = 16;
      PDF.setFontSize(brandBaseSize);
      const brandWidth = PDF.getTextWidth(brandName);
      let brandFontSize = brandBaseSize;
      if (brandWidth > brandMaxWidth) {
        brandFontSize = Math.max(brandMinSize, Math.floor(brandBaseSize * (brandMaxWidth / brandWidth)));
      }
      PDF.setFontSize(brandFontSize);

      // Sits below the logo rather than level with it.
      const brandY = headingY + 0.08;
      PDF.setTextColor(22, 53, 73);
      PDF.text(brandName, pageCenterX, brandY, { align: "center" });

      PDF.setFontSize(22);
      const reportName =
        this.selectedSection.charAt(0).toUpperCase() +
        this.selectedSection.slice(1).toLowerCase() +
        " Report";
      PDF.text(reportName, pageCenterX, reportTypeY, { align: "center" });

      PDF.setFontSize(13);
      PDF.setTextColor(124, 141, 153);
      const startMoment = moment(this.selectedFilters.start_date);
      const endMoment = moment(this.selectedFilters.end_date);
      // Show the start year too when the range crosses years.
      let formattedStartDate = startMoment.format("MMMM D");
      if (startMoment.year() !== endMoment.year()) {
        formattedStartDate = startMoment.format("MMMM D, YYYY");
      }
      const formattedEndDate = endMoment.format("MMMM D, YYYY");
      PDF.text(`${formattedStartDate} - ${formattedEndDate}`, pageCenterX, dateY, {
        align: "center",
      });

      const imgFooter = new Image();
      imgFooter.src = "/assets/img/report-footer.png";
      const imgFooterWidth = pdfReportPageWidthIn;
      const imgFooterHeight = pdfReportFooterHeightIn;
      const imgFooterY = pdfReportPageHeightIn - imgFooterHeight;

      const reportContainer = document.getElementById(this.selectedSection);
      const pageSlices = pdfReportPageSlices(reportContainer, this.selectedSection);
      const inchesPerPx = pdfReportPageWidthIn / reportContainer.offsetWidth;

      for (let index = 0; index < pageSlices.length; index++) {
        const pagePadding = pdfReportPagePaddingIn(this.selectedSection, index);
        let pageScale = 5;

        if (index > 0) {
          pageScale = 10;

          PDF.addPage();
          PDF.setFillColor(240, 240, 240);
          PDF.rect(0, 0, pdfReportPageWidthIn, headerHeight, "F");
          PDF.addImage(img, "JPEG", imgX, 0, imgWidth, headerHeight);

          PDF.setTextColor(22, 53, 73);
          PDF.setFontSize(brandFontSize);
          PDF.text(brandName, pageCenterX, brandY, { align: "center" });

          PDF.setFontSize(22);
          PDF.text(reportName, pageCenterX, reportTypeY, { align: "center" });

          PDF.setFontSize(13);
          PDF.setTextColor(124, 141, 153);
          PDF.text(`${formattedStartDate} - ${formattedEndDate}`, pageCenterX, dateY, {
            align: "center",
          });
        }

        const slice = pageSlices[index];
        const canvas = await html2canvas(reportContainer, {
          scrollX: 0,
          scrollY: 0,
          scale: pageScale,
          y: slice.top,
          height: slice.height,
        });
        const sliceHeightIn = slice.height * inchesPerPx;
        PDF.addImage(
          canvas.toDataURL("image/jpeg"),
          "JPEG",
          0,
          headerHeight + pagePadding,
          pdfReportPageWidthIn,
          sliceHeightIn
        );
        PDF.addImage(imgFooter, "PNG", 0, imgFooterY, imgFooterWidth, imgFooterHeight);
      }

      PDF.save(`${reportName} (${formattedStartDate} ${formattedEndDate})`);
      this.finishReportDownload();
    } catch (error) {
      this.failReportDownload();
    }
  }

  get isOverviewSection() {
    return this.selectedSection === DashboardSections.Overview;
  }

  get isRetentionSection() {
    return this.selectedSection === DashboardSections.Retention;
  }

  get isMarketplaceSection() {
    return this.selectedSection === DashboardSections.Marketplace;
  }

  get isPhoneSection() {
    return this.selectedSection === DashboardSections.Phone;
  }

  get isSubscriptionSection() {
    return this.selectedSection === DashboardSections.Subscription;
  }

  get isOrdersSection() {
    return this.selectedSection === DashboardSections.Order;
  }

  get isReturnsSection() {
    return this.selectedSection === DashboardSections.Return;
  }

  get isResolveSection() {
    return this.selectedSection === DashboardSections.Resolve;
  }

  get showSectionTabs() {
    return this.pageSections.length > 1 || this.isResolveSection;
  }

  // Spin until the last response lands - nothing in this row depends on Postgres anymore.
  get isOverviewKpiCardsLoading(): boolean {
    return (
      topIntentsDoughnutData.loading ||
      this.overviewOrderKpiLoading ||
      this.overviewSubscriptionKpiLoading ||
      // Revenue Saved needs both money_cards responses.
      this.isOverviewDualCardSubtitlesLoading
    );
  }

  get isOverviewDualCardSubtitlesLoading(): boolean {
    return this.overviewDualCards.some((card) => card.subtitleLoading === true);
  }

  get isOverviewReportDataLoading(): boolean {
    return (
      this.isOverviewKpiCardsLoading ||
      this.isOverviewDualCardSubtitlesLoading ||
      this.isOverviewRefundsStatsLoading ||
      this.topOrderCancellationReasons.loading ||
      this.topSubscriptionCancellationReasons.loading ||
      this.topReturnReasons.loading ||
      topIntentsDoughnutData.loading ||
      faqs.loading
    );
  }

  // Three endpoints, no flag between them; the spinner keys off the empty value.
  get isOverviewRefundsStatsLoading(): boolean {
    return (
      returnSummaryInfoCards.some((card) => !card.value) ||
      returnSummaryDualCards.some((card) => !card.leftVal || !card.rightVal)
    );
  }

  // One flag per fetch the report renders.
  get isOrdersReportDataLoading(): boolean {
    return (
      this.kpiCardsLoading ||
      ordersBillingState.loading ||
      this.ordersDoughnutData.loading ||
      this.ordersCancellationReasons.loading ||
      this.ordersOfferTypeData.loading ||
      this.ordersProductData.loading ||
      this.ordersCampaignData.loading ||
      this.ordersCustomerStageData.loading
    );
  }

  get isSubscriptionReportDataLoading(): boolean {
    return (
      this.kpiCardsLoading ||
      this.subscriptionDoughnutData.loading ||
      this.subscriptionCancellationReasons.loading ||
      this.subscriptionOfferTypeData.loading ||
      this.subscriptionProductData.loading ||
      this.subscriptionBillingCycleData.loading ||
      this.subscriptionFrequencyData.loading ||
      this.subscriptionCampaignData.loading ||
      this.subscriptionCustomerStageData.loading ||
      this.canceledWithPendingOrderData.loading
    );
  }

  // One flag per fetch the report renders; AI insights loads too but the report omits it.
  get isReturnsReportDataLoading(): boolean {
    return (
      this.kpiCardsLoading ||
      this.returnsMoneyCardsLoading ||
      this.returnsActivityLoading ||
      this.returnsOutcomesData.loading ||
      this.returnsReasons.loading ||
      this.returnsProducts.loading ||
      this.returnsOffers.loading
    );
  }

  storeDashboardNavFilters() {
    const filter = this.dashboardService.getFilter();
    const excludeAbandons = filter.exclude_abandons;
    const excludePrefulfillmentCancels = filter.exclude_prefulfillment_cancels;
    const navFilters: DashboardNavFilters = {
      start_date: filter.start_date,
      end_date: filter.end_date,
    };
    if (filter.campaign_id) {
      navFilters['campaign_id'] = filter.campaign_id;
    }
    if (filter.offer_intent) {
      navFilters['offer_intent'] = filter.offer_intent;
    }
    if (filter.product_id) {
      navFilters['product_id'] = filter.product_id;
      navFilters['product_name'] = filter.product_name;
    }
    if (excludeAbandons) {
      navFilters['exclude_abandons'] = excludeAbandons;
    }
    if (excludePrefulfillmentCancels) {
      navFilters['exclude_prefulfillment_cancels'] = excludePrefulfillmentCancels;
    }
    this.storageService.set('dashboard_nav_filters', navFilters);
  }

  navigateToReport(dimension: string, section?: DashboardSections) {
    this.storeDashboardNavFilters();
    const reportSection = DashboardReportSection[section || this.selectedSection] || 'order';
    const reportPath = `/${reportSection}-retention-report-v3/dim/`;
    window.open(reportPath + dimension, '_blank');
  }

  navigateToResolveReport(dimension: string) {
    this.storeDashboardNavFilters();
    window.open(`/resolve-report/dim/${dimension}`, '_blank');
  }

  navigateToCustomerSupportReport(dimension?: string) {
    this.storeDashboardNavFilters();
    let reportPath = '/customer-support-report';
    if (dimension) {
      reportPath = `${reportPath}/dim/${dimension}`;
    }
    window.open(reportPath, '_blank');
  }

  /* ======================SUBSCRIPTION=======================*/

  getSubscriptionTopCardsData() {
    this.subscriptionTopCardsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: KpiCardsResponse) => {
        if (apiData) {
          this.kpiCardsLoading = false;
          if (apiData.cards && apiData.cards.length > 0) {
            const cardMap: { [key: string]: KpiCard } = {};
            apiData.cards.forEach((card: KpiCard) => {
              cardMap[card.key] = card;
            });

            const cancelCard = cardMap[KpiCardKey.CancelRequests];
            if (cancelCard) {
              this.subscriptionTopCardsData[SubscriptionInfo.CancelRequests].value = cancelCard.value.toLocaleString();
              this.subscriptionTopCardsData[SubscriptionInfo.CancelRequests].percentage =
                (cancelCard.trend_pct !== null && cancelCard.trend_pct !== 0) ? Math.abs(cancelCard.trend_pct) : null;
              this.subscriptionTopCardsData[SubscriptionInfo.CancelRequests].is_negative =
                (cancelCard.trend_pct !== null && cancelCard.trend_pct !== 0) ? cancelCard.trend_pct < 0 : false;
              if (cancelCard.pct !== null) {
                this.subscriptionTopCardsData[SubscriptionInfo.CancelRequests].subtitle = `${cancelCard.pct.toFixed(1)}% of Total`;
              }
            }

            const savedCard = cardMap[KpiCardKey.Saved];
            if (savedCard) {
              this.subscriptionTopCardsData[SubscriptionInfo.Saved].value = savedCard.value.toLocaleString();
              this.subscriptionTopCardsData[SubscriptionInfo.Saved].percentage =
                (savedCard.trend_pct !== null && savedCard.trend_pct !== 0) ? Math.abs(savedCard.trend_pct) : null;
              this.subscriptionTopCardsData[SubscriptionInfo.Saved].is_negative =
                (savedCard.trend_pct !== null && savedCard.trend_pct !== 0) ? savedCard.trend_pct < 0 : false;
              if (savedCard.pct !== null) {
                this.subscriptionTopCardsData[SubscriptionInfo.Saved].subtitle =
                  savedCard.pct !== 0 ? `${savedCard.pct.toFixed(1)}% Save Rate` : '--';
              }
            }

            const savedRevenueCard = cardMap[KpiCardKey.SavedRevenue];
            if (savedRevenueCard) {
              this.subscriptionTopCardsData[SubscriptionInfo.SavedRevenue].value = '$' + formatMoney(savedRevenueCard.value);
              this.subscriptionTopCardsData[SubscriptionInfo.SavedRevenue].percentage =
                (savedRevenueCard.trend_pct !== null && savedRevenueCard.trend_pct !== 0) ? Math.abs(savedRevenueCard.trend_pct) : null;
              this.subscriptionTopCardsData[SubscriptionInfo.SavedRevenue].is_negative =
                (savedRevenueCard.trend_pct !== null && savedRevenueCard.trend_pct !== 0) ? savedRevenueCard.trend_pct < 0 : false;
            }

            const cancelledCard = cardMap[KpiCardKey.Cancelled];
            if (cancelledCard) {
              this.subscriptionTopCardsData[SubscriptionInfo.Cancelled].value = cancelledCard.value.toLocaleString();
              this.subscriptionTopCardsData[SubscriptionInfo.Cancelled].percentage =
                (cancelledCard.trend_pct !== null && cancelledCard.trend_pct !== 0) ? Math.abs(cancelledCard.trend_pct) : null;
              this.subscriptionTopCardsData[SubscriptionInfo.Cancelled].is_negative =
                (cancelledCard.trend_pct !== null && cancelledCard.trend_pct !== 0) ? cancelledCard.trend_pct < 0 : false;
              if (cancelledCard.pct !== null) {
                this.subscriptionTopCardsData[SubscriptionInfo.Cancelled].subtitle =
                  cancelledCard.pct !== 0 ? `${cancelledCard.pct.toFixed(1)}% of Total` : '--';
              }
            }

            const retentionCard = cardMap[KpiCardKey.RetentionRate];
            const abandonedCard = cardMap[KpiCardKey.Abandoned];
            if (retentionCard) {
              this.subscriptionTopCardsData[SubscriptionInfo.RetentionRate].value = `${retentionCard.value.toFixed(1)}%`;
              this.subscriptionTopCardsData[SubscriptionInfo.RetentionRate].percentage =
                (retentionCard.trend_pct !== null && retentionCard.trend_pct !== 0) ? Math.abs(retentionCard.trend_pct) : null;
              this.subscriptionTopCardsData[SubscriptionInfo.RetentionRate].is_negative =
                (retentionCard.trend_pct !== null && retentionCard.trend_pct !== 0) ? retentionCard.trend_pct < 0 : false;
              if (isDefined(retentionCard.pct) && retentionCard.pct !== 0) {
                this.subscriptionTopCardsData[SubscriptionInfo.RetentionRate].subtitle =
                  `${retentionCard.pct.toFixed(1)}% of Cancellations Retained`;
              } else if (this.dashboardService.getFilter().exclude_abandons) {
                this.subscriptionTopCardsData[SubscriptionInfo.RetentionRate].subtitle = 'Abandons Excluded';
              } else if (abandonedCard) {
                let abandonedSubtitle = `${abandonedCard.value.toLocaleString()} Abandoned`;
                if (isDefined(abandonedCard.pct) && abandonedCard.pct !== 0) {
                  abandonedSubtitle += ` (${abandonedCard.pct.toFixed(1)}% of Total)`;
                }
                this.subscriptionTopCardsData[SubscriptionInfo.RetentionRate].subtitle = abandonedSubtitle;
              }
            }
          } else {
            this.subscriptionTopCardsData[SubscriptionInfo.CancelRequests].value = '0';
            this.subscriptionTopCardsData[SubscriptionInfo.Saved].value = '0';
            this.subscriptionTopCardsData[SubscriptionInfo.SavedRevenue].value = '$0';
            this.subscriptionTopCardsData[SubscriptionInfo.Cancelled].value = '0';
            this.subscriptionTopCardsData[SubscriptionInfo.RetentionRate].value = '0%';
          }
        }
      });
  }

  getSubscriptionSummaryData() {
    this.subscriptionSummaryService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: RetentionSummaryV2Response) => {
        if (apiData) {
          this.subscriptionDoughnutData.loading = false;
          this.subscriptionDoughnutData.noData = false;

          if (isObjectEmpty(apiData)) {
            this.subscriptionDoughnutData.noData = true;
          } else {
            const data = apiData as RetentionSummaryV2Response;
            const saves = data.items_saved || 0;
            const cancels = data.items_cancelled || 0;
            const abandons = data.items_abandoned || 0;
            const total = saves + cancels + abandons;

            if (total === 0) {
              this.subscriptionDoughnutData.noData = true;
            } else {
              this.subscriptionDoughnutData.data = [saves, cancels, abandons, 0];
              this.subscriptionDoughnutData.total = total.toLocaleString();
            }

            this.subscriptionSummaryTableData[0].value = saves.toLocaleString();
            this.subscriptionSummaryTableData[0].percentage = total > 0 ? `${((saves / total) * 100).toFixed(1)}%` : '0%';
            this.subscriptionSummaryTableData[1].value = cancels.toLocaleString();
            this.subscriptionSummaryTableData[1].percentage = total > 0 ? `${((cancels / total) * 100).toFixed(1)}%` : '0%';
            this.subscriptionSummaryTableData[2].value = abandons.toLocaleString();
            this.subscriptionSummaryTableData[2].percentage = total > 0 ? `${((abandons / total) * 100).toFixed(1)}%` : '0%';
            this.subscriptionSummaryTableData[3].value = '0';
            this.subscriptionSummaryTableData[3].percentage = '0%';
          }
        }
      });
  }

  getSubscriptionCancellationReasonsData() {
    this.subscriptionCancellationReasonsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: TopCancellationReasonsResponse) => {
        if (apiData) {
          this.subscriptionCancellationReasons.loading = false;
          this.subscriptionCancellationReasons.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.subscriptionCancellationReasons.data = apiData.results.map((item: CancellationReasonRow) => ({
              name: item.reason,
              requests: item.requests,
              series: [
                { name: RetentionSegment.Saved, value: item.saved },
                { name: RetentionSegment.Cancelled, value: item.cancelled },
                { name: RetentionSegment.Abandoned, value: item.abandoned },
              ],
            }));
          } else {
            this.subscriptionCancellationReasons.noData = true;
            this.subscriptionCancellationReasons.data = [];
          }
        }
      });
  }

  getSubscriptionOfferTypeData() {
    this.subscriptionOfferTypeService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: OfferTypeResponse) => {
        if (apiData) {
          this.subscriptionOfferTypeData.loading = false;
          this.subscriptionOfferTypeData.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.subscriptionOfferTypeData.data = apiData.results.map((item: OfferTypeRow) => ({
              name: StepCategoryLabels[item.offer_type] || `Unknown (${item.offer_type})`,
              requests: (item.requests || 0).toLocaleString(),
              saves: item.saves.toLocaleString(),
              saveRate: `${item.save_pct.toFixed(2)}%`,
            }));
          } else {
            this.subscriptionOfferTypeData.noData = true;
            this.subscriptionOfferTypeData.data = [];
          }
        }
      });
  }

  // both product APIs fire in parallel; each stores its result then defers tab selection to autoSelect
  getSubscriptionProductData() {
    this.subscriptionProductService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: PerformanceTableResponse) => {
        if (apiData) {
          let mapped = [];
          if (apiData.results && apiData.results.length > 0) {
            mapped = apiData.results.map((item: PerformanceRow) => ({
              name: String(item.dimension) || '--',
              requests: item.requests.toLocaleString(),
              saves: item.saves.toLocaleString(),
              saveRate: `${item.save_pct.toFixed(2)}%`,
            }));
          }
          this.subscriptionProductData.baseData = mapped;
          this.autoSelectSubscriptionProductTab();
        }
      });
  }

  getSubscriptionCampaignProductData() {
    this.subscriptionCampaignProductService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: PerformanceTableResponse) => {
        if (apiData) {
          let mapped = [];
          if (apiData.results && apiData.results.length > 0) {
            mapped = apiData.results.map((item: PerformanceRow) => ({
              name: String(item.dimension) || '--',
              requests: item.requests.toLocaleString(),
              saves: item.saves.toLocaleString(),
              saveRate: `${item.save_pct.toFixed(2)}%`,
            }));
          }
          this.subscriptionProductData.campaignData = mapped;
          this.autoSelectSubscriptionProductTab();
        }
      });
  }

  // runs only when both APIs have returned (null = not yet loaded); picks first tab with data
  autoSelectSubscriptionProductTab() {
    if (this.subscriptionProductData.baseData !== null && this.subscriptionProductData.campaignData !== null) {
      if (this.subscriptionProductData.baseData.length > 0) {
        this.subscriptionProductData.type = ProductViewType.Base;
        this.subscriptionProductData.data = this.subscriptionProductData.baseData;
        this.subscriptionProductData.noData = false;
      } else if (this.subscriptionProductData.campaignData.length > 0) {
        this.subscriptionProductData.type = ProductViewType.Campaign;
        this.subscriptionProductData.data = this.subscriptionProductData.campaignData;
        this.subscriptionProductData.noData = false;
      } else {
        this.subscriptionProductData.type = ProductViewType.Base;
        this.subscriptionProductData.data = [];
        this.subscriptionProductData.noData = true;
      }
      this.subscriptionProductData.loading = false;
    }
  }

  getSubscriptionBillingCycleData() {
    this.subscriptionBillingCycleService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: PerformanceTableResponse) => {
        if (apiData) {
          this.subscriptionBillingCycleData.loading = false;
          this.subscriptionBillingCycleData.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.subscriptionBillingCycleData.data = apiData.results.map((item: PerformanceRow) => ({
              name: `Cycle - ${item.dimension}`,
              requests: item.requests,
              series: [
                { name: RetentionSegment.Saved, value: item.saves },
                { name: RetentionSegment.Cancelled, value: item.cancelled },
                { name: RetentionSegment.Abandoned, value: item.abandoned },
              ],
            }));
          } else {
            this.subscriptionBillingCycleData.noData = true;
            this.subscriptionBillingCycleData.data = [];
          }
        }
      });
  }

  getSubscriptionFrequencyData() {
    this.subscriptionFrequencyService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: PerformanceTableResponse) => {
        if (apiData) {
          this.subscriptionFrequencyData.loading = false;
          this.subscriptionFrequencyData.noData = false;

          if (apiData.pending) {
            this.subscriptionFrequencyData.noData = true;
            this.subscriptionFrequencyData.data = [];
          } else {
            if (apiData.results && apiData.results.length > 0) {
              this.subscriptionFrequencyData.data = apiData.results.map((item: PerformanceRow) => ({
                name: formatBillingIntervalDays(item.dimension),
                requests: item.requests,
                series: [
                  { name: RetentionSegment.Saved, value: item.saves },
                  { name: RetentionSegment.Cancelled, value: item.cancelled },
                  { name: RetentionSegment.Abandoned, value: item.abandoned },
                ],
              }));
            } else {
              this.subscriptionFrequencyData.noData = true;
              this.subscriptionFrequencyData.data = [];
            }
          }
        }
      });
  }

  getSubscriptionCampaignData() {
    this.subscriptionCampaignService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: PerformanceTableResponse) => {
        if (apiData) {
          this.subscriptionCampaignData.loading = false;
          this.subscriptionCampaignData.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.subscriptionCampaignData.data = apiData.results.map((item: PerformanceRow) => ({
              name: String(item.dimension),
              requests: item.requests.toLocaleString(),
              saves: item.saves.toLocaleString(),
              saveRate: `${item.save_pct.toFixed(2)}%`,
            }));
          } else {
            this.subscriptionCampaignData.noData = true;
            this.subscriptionCampaignData.data = [];
          }
        }
      });
  }

  getSubscriptionCustomerStageData() {
    this.subscriptionCustomerStageService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: PerformanceTableResponse) => {
        if (apiData) {
          this.subscriptionCustomerStageData.loading = false;
          this.subscriptionCustomerStageData.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.subscriptionCustomerStageData.data = apiData.results.map((item: PerformanceRow) => ({
              name: String(item.dimension),
              requests: (item.requests || 0).toLocaleString(),
              saves: item.saves.toLocaleString(),
              saveRate: `${item.save_pct.toFixed(2)}%`,
            }));
          } else {
            this.subscriptionCustomerStageData.noData = true;
            this.subscriptionCustomerStageData.data = [];
          }
        }
      });
  }

  getSubscriptionCanceledWithPendingOrderData() {
    this.subscriptionCanceledWithPendingOrderService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: CanceledWithPendingOrderResponse) => {
        if (apiData) {
          this.canceledWithPendingOrderData.loading = false;
          if (isDefined(apiData.quantity) && apiData.quantity !== 0) {
            this.canceledWithPendingOrderData.show = true;
            this.canceledWithPendingOrderData.quantity = apiData.quantity.toLocaleString();
            this.canceledWithPendingOrderData.subscriptionValueLost = '$' + formatMoney(apiData.value_lost);
            if (isDefined(apiData.pct_of_cancellations)) {
              this.canceledWithPendingOrderData.cancellationRate = `${apiData.pct_of_cancellations.toFixed(1)}%`;
            }
            if (apiData.cycle_1 && isDefined(apiData.cycle_1.quantity)) {
              this.canceledWithPendingOrderData.cycle1Quantity = apiData.cycle_1.quantity.toLocaleString();
            }
            if (apiData.cycle_1) {
              this.canceledWithPendingOrderData.cycle1Value = '$' + formatMoney(apiData.cycle_1.value);
            }
            if (apiData.cycle_2_plus && isDefined(apiData.cycle_2_plus.quantity)) {
              this.canceledWithPendingOrderData.cycle2Quantity = apiData.cycle_2_plus.quantity.toLocaleString();
            }
            if (apiData.cycle_2_plus) {
              this.canceledWithPendingOrderData.cycle2Value = '$' + formatMoney(apiData.cycle_2_plus.value);
            }
            this.canceledWithPendingOrderData.avgValue = '$' + formatMoney(apiData.avg_value);
          } else {
            this.canceledWithPendingOrderData.show = false;
          }
        }
      });
  }

  /* ======================ORDERS=======================*/

  getOrdersKpiCardsData() {
    this.ordersKpiCardsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: KpiCardsResponse) => {
        if (apiData) {
          this.kpiCardsLoading = false;
          if (apiData.cards && apiData.cards.length > 0) {
            // First pass: collect all cards into a map for cross-referencing
            const cardMap: { [key: string]: KpiCard } = {};
            apiData.cards.forEach((card: KpiCard) => {
              cardMap[card.key] = card;
            });

            // Second pass: populate display cards using cross-references where needed
            const abandonedCard = cardMap[KpiCardKey.Abandoned];
            const cancelCard = cardMap[KpiCardKey.CancelRequests];
            if (cancelCard) {
              this.ordersTopCardsData[OrdersInfo.CancelRequests].value = cancelCard.value.toLocaleString();
              this.ordersTopCardsData[OrdersInfo.CancelRequests].percentage =
                (cancelCard.trend_pct !== null && cancelCard.trend_pct !== 0) ? Math.abs(cancelCard.trend_pct) : null;
              this.ordersTopCardsData[OrdersInfo.CancelRequests].is_negative =
                (cancelCard.trend_pct !== null && cancelCard.trend_pct !== 0) ? cancelCard.trend_pct < 0 : false;
              if (cancelCard.pct !== null) {
                this.ordersTopCardsData[OrdersInfo.CancelRequests].subtitle = `${cancelCard.pct.toFixed(1)}% of Sessions`;
              }
              const cancelledCard = cardMap[KpiCardKey.Cancelled];
              this.ordersTopCardsData[OrdersInfo.CancelRequests].subtitleItems = [
                { label: 'Cancelled', value: cancelledCard ? cancelledCard.value.toLocaleString() : '--' },
                { label: 'Abandoned', value: abandonedCard ? abandonedCard.value.toLocaleString() : '--' },
              ];
            }

            const savedCard = cardMap[KpiCardKey.Saved];
            if (savedCard) {
              this.ordersTopCardsData[OrdersInfo.Saved].value = savedCard.value.toLocaleString();
              this.ordersTopCardsData[OrdersInfo.Saved].percentage =
                (savedCard.trend_pct !== null && savedCard.trend_pct !== 0) ? Math.abs(savedCard.trend_pct) : null;
              this.ordersTopCardsData[OrdersInfo.Saved].is_negative =
                (savedCard.trend_pct !== null && savedCard.trend_pct !== 0) ? savedCard.trend_pct < 0 : false;
              this.ordersTopCardsData[OrdersInfo.Saved].subtitleItems = [
                { label: 'Save Rate', value: savedCard.pct !== null ? `${savedCard.pct.toFixed(1)}%` : '--' },
              ];
            }

            const retentionCard = cardMap[KpiCardKey.RetentionRate];
            if (retentionCard) {
              this.ordersTopCardsData[OrdersInfo.RetentionRate].value = `${retentionCard.value.toFixed(1)}%`;
              this.ordersTopCardsData[OrdersInfo.RetentionRate].percentage =
                (retentionCard.trend_pct !== null && retentionCard.trend_pct !== 0) ? Math.abs(retentionCard.trend_pct) : null;
              this.ordersTopCardsData[OrdersInfo.RetentionRate].is_negative =
                (retentionCard.trend_pct !== null && retentionCard.trend_pct !== 0) ? retentionCard.trend_pct < 0 : false;
              if (isDefined(retentionCard.pct) && retentionCard.pct !== 0) {
                this.ordersTopCardsData[OrdersInfo.RetentionRate].subtitle =
                  `${retentionCard.pct.toFixed(1)}% of Cancellations Retained`;
              } else if (this.dashboardService.getFilter().exclude_abandons) {
                this.ordersTopCardsData[OrdersInfo.RetentionRate].subtitle = 'Abandons Excluded';
              } else if (abandonedCard) {
                let abandonedSubtitle = `${abandonedCard.value.toLocaleString()} Abandoned`;
                if (isDefined(abandonedCard.pct) && abandonedCard.pct !== 0) {
                  abandonedSubtitle += ` (${abandonedCard.pct.toFixed(1)}% of Total)`;
                }
                this.ordersTopCardsData[OrdersInfo.RetentionRate].subtitle = abandonedSubtitle;
              }
            }
          } else {
            this.ordersTopCardsData[OrdersInfo.CancelRequests].value = '0';
            this.ordersTopCardsData[OrdersInfo.Saved].value = '0';
            this.ordersTopCardsData[OrdersInfo.RevenueSaved].value = '$0.00';
            this.ordersTopCardsData[OrdersInfo.RetentionRate].value = '0%';
          }
        }
      });
  }

  getOrdersRetentionSummaryData() {
    this.ordersRetentionSummaryService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: RetentionSummaryV2Response) => {
        if (apiData) {
          this.ordersDoughnutData.loading = false;
          this.ordersDoughnutData.noData = false;

          if (isObjectEmpty(apiData)) {
            this.ordersDoughnutData.noData = true;
          } else {
            const data = apiData as RetentionSummaryV2Response;
            const saves = data.items_saved || 0;
            const cancels = data.items_cancelled || 0;
            const abandons = data.items_abandoned || 0;
            const total = saves + cancels + abandons;

            if (total === 0) {
              this.ordersDoughnutData.noData = true;
            } else {
              this.ordersDoughnutData.data = [saves, cancels, abandons, 0];
              this.ordersDoughnutData.total = total.toLocaleString();
            }

            this.ordersSummaryTableData[0].value = saves.toLocaleString();
            this.ordersSummaryTableData[0].percentage = total > 0 ? `${((saves / total) * 100).toFixed(1)}%` : '0%';
            this.ordersSummaryTableData[1].value = cancels.toLocaleString();
            this.ordersSummaryTableData[1].percentage = total > 0 ? `${((cancels / total) * 100).toFixed(1)}%` : '0%';
            this.ordersSummaryTableData[2].value = abandons.toLocaleString();
            this.ordersSummaryTableData[2].percentage = total > 0 ? `${((abandons / total) * 100).toFixed(1)}%` : '0%';
            this.ordersSummaryTableData[3].value = '0';
            this.ordersSummaryTableData[3].percentage = '0%';
          }
        }
      });
  }

  getOrdersCancellationReasonsData() {
    this.ordersCancellationReasonsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: TopCancellationReasonsResponse) => {
        if (apiData) {
          this.ordersCancellationReasons.loading = false;
          this.ordersCancellationReasons.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.ordersCancellationReasons.data = apiData.results.map((item: CancellationReasonRow) => ({
              name: item.reason,
              requests: item.requests,
              series: [
                { name: RetentionSegment.Saved, value: item.saved },
                { name: RetentionSegment.Cancelled, value: item.cancelled },
                { name: RetentionSegment.Abandoned, value: item.abandoned },
              ],
            }));
          } else {
            this.ordersCancellationReasons.noData = true;
            this.ordersCancellationReasons.data = [];
          }
        }
      });
  }

  getOrdersMoneyCardsData() {
    this.ordersMoneyCardsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: MoneyCardsResponse) => {
        if (apiData) {
          ordersBillingState.loading = false;
          if (apiData.cards && apiData.cards.length > 0) {
            apiData.cards.forEach((card: MoneyCard) => {
              const formattedDecimal = `$${card.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
              if (card.key === MoneyCardKey.TotalBilled) {
                this.ordersBillingDualCards[0].leftVal = formattedDecimal;
              }
              if (card.key === MoneyCardKey.TotalRefunds) {
                this.ordersBillingDualCards[0].rightVal = formattedDecimal;
              }
              if (card.key === MoneyCardKey.PartialRefunds) {
                this.ordersBillingDualCards[1].leftVal = formattedDecimal;
                this.ordersBillingDualCards[1].leftSubtitle = card.pct !== null ? `${card.pct.toFixed(1)}% Refunds` : null;
              }
              if (card.key === MoneyCardKey.FullRefunds) {
                this.ordersBillingDualCards[1].rightVal = formattedDecimal;
                this.ordersBillingDualCards[1].rightSubtitle = card.pct !== null ? `${card.pct.toFixed(1)}% Refunds` : null;
              }
              if (card.key === MoneyCardKey.AvgRefund) {
                this.ordersBillingSingleCards[0].value = formattedDecimal;
                this.ordersBillingSingleCards[0].trend_pct = card.trend_pct !== undefined ? card.trend_pct : null;
              }
              if (card.key === MoneyCardKey.RevenueSaved) {
                this.ordersTopCardsData[OrdersInfo.RevenueSaved].value = formattedDecimal;
                this.ordersTopCardsData[OrdersInfo.RevenueSaved].percentage =
                  (card.trend_pct !== null && card.trend_pct !== undefined && card.trend_pct !== 0) ? Math.abs(card.trend_pct) : null;
                this.ordersTopCardsData[OrdersInfo.RevenueSaved].is_negative =
                  (card.trend_pct !== null && card.trend_pct !== undefined && card.trend_pct !== 0) ? card.trend_pct < 0 : false;
              }
              if (card.key === MoneyCardKey.NetRevenue) {
                this.ordersBillingSingleCards[1].value = formattedDecimal;
                this.ordersBillingSingleCards[1].trend_pct = card.trend_pct !== undefined ? card.trend_pct : null;
              }
            });
          }
        }
      });
  }

  getOrdersOfferTypeData() {
    this.ordersOfferTypeService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: OfferTypeResponse) => {
        if (apiData) {
          this.ordersOfferTypeData.loading = false;
          this.ordersOfferTypeData.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.ordersOfferTypeData.data = apiData.results.map((item: OfferTypeRow) => ({
              name: StepCategoryLabels[item.offer_type] || `Unknown (${item.offer_type})`,
              requests: (item.requests || 0).toLocaleString(),
              saves: item.saves.toLocaleString(),
              saveRate: `${item.save_pct.toFixed(2)}%`,
            }));
          } else {
            this.ordersOfferTypeData.noData = true;
            this.ordersOfferTypeData.data = [];
          }
        }
      });
  }

  getOrdersProductData() {
    this.ordersProductService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: PerformanceTableResponse) => {
        if (apiData) {
          let mapped = [];
          if (apiData.results && apiData.results.length > 0) {
            mapped = apiData.results.map((item: PerformanceRow) => ({
              name: String(item.dimension) || '--',
              requests: item.requests.toLocaleString(),
              saves: item.saves.toLocaleString(),
              saveRate: `${item.save_pct.toFixed(2)}%`,
            }));
          }
          this.ordersProductData.baseData = mapped;
          this.autoSelectOrdersProductTab();
        }
      });
  }

  getOrdersCampaignProductData() {
    this.ordersCampaignProductService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: PerformanceTableResponse) => {
        if (apiData) {
          let mapped = [];
          if (apiData.results && apiData.results.length > 0) {
            mapped = apiData.results.map((item: PerformanceRow) => ({
              name: String(item.dimension) || '--',
              requests: item.requests.toLocaleString(),
              saves: item.saves.toLocaleString(),
              saveRate: `${item.save_pct.toFixed(2)}%`,
            }));
          }
          this.ordersProductData.campaignData = mapped;
          this.autoSelectOrdersProductTab();
        }
      });
  }

  // runs only when both APIs have returned (null = not yet loaded); picks first tab with data
  autoSelectOrdersProductTab() {
    if (this.ordersProductData.baseData !== null && this.ordersProductData.campaignData !== null) {
      if (this.ordersProductData.baseData.length > 0) {
        this.ordersProductData.type = ProductViewType.Base;
        this.ordersProductData.data = this.ordersProductData.baseData;
        this.ordersProductData.noData = false;
      } else if (this.ordersProductData.campaignData.length > 0) {
        this.ordersProductData.type = ProductViewType.Campaign;
        this.ordersProductData.data = this.ordersProductData.campaignData;
        this.ordersProductData.noData = false;
      } else {
        this.ordersProductData.type = ProductViewType.Base;
        this.ordersProductData.data = [];
        this.ordersProductData.noData = true;
      }
      this.ordersProductData.loading = false;
    }
  }

  getOrdersCampaignData() {
    this.ordersCampaignService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: PerformanceTableResponse) => {
        if (apiData) {
          this.ordersCampaignData.loading = false;
          this.ordersCampaignData.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.ordersCampaignData.data = apiData.results.map((item: PerformanceRow) => ({
              name: String(item.dimension),
              requests: item.requests.toLocaleString(),
              saves: item.saves.toLocaleString(),
              saveRate: `${item.save_pct.toFixed(2)}%`,
            }));
          } else {
            this.ordersCampaignData.noData = true;
            this.ordersCampaignData.data = [];
          }
        }
      });
  }

  getOrdersCustomerStageData() {
    this.ordersCustomerStageService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: PerformanceTableResponse) => {
        if (apiData) {
          this.ordersCustomerStageData.loading = false;
          this.ordersCustomerStageData.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.ordersCustomerStageData.data = apiData.results.map((item: PerformanceRow) => ({
              name: String(item.dimension),
              requests: (item.requests || 0).toLocaleString(),
              saves: item.saves.toLocaleString(),
              saveRate: `${item.save_pct.toFixed(2)}%`,
            }));
          } else {
            this.ordersCustomerStageData.noData = true;
            this.ordersCustomerStageData.data = [];
          }
        }
      });
  }

  // Avg. Request = total_billed / cancel_requests, but kpi_cards and money_cards resolve independently.
  private returnsCancelRequestsCount = 0;
  private returnsTotalBilledAmount = 0;

  private recomputeReturnsAvgRequest() {
    const avgRequest = this.returnsCancelRequestsCount > 0 ? this.returnsTotalBilledAmount / this.returnsCancelRequestsCount : 0;
    this.setReturnsSubMetric(
      this.returnsTopCards[ReturnsCardIndex.RequestedReturnValue],
      ReturnsKpiSubMetricKey.AvgRequest,
      `$${formatMoney(avgRequest)}`,
    );
  }

  private applyReturnsTrend(card: ReturnsKpiCard, trendPct: number | null | undefined) {
    const hasTrend = trendPct !== null && trendPct !== undefined && trendPct !== 0;
    card.percentage = hasTrend ? Math.abs(trendPct) : null;
    card.is_negative = hasTrend ? trendPct < 0 : false;
  }

  // Shows the actual prior-period number next to the trend %, not just the % on its own.
  private formatReturnsPreviousValue(previousValue: number | null | undefined): string | null {
    return previousValue !== null && previousValue !== undefined ? `was ${previousValue.toLocaleString()}` : null;
  }

  private formatReturnsPreviousMoney(previousValue: number | null | undefined): string | null {
    return previousValue !== null && previousValue !== undefined ? `was $${formatMoney(previousValue)}` : null;
  }

  private setReturnsSubMetric(card: ReturnsKpiCard, key: ReturnsKpiSubMetricKey, value: string) {
    const subMetric = card.subMetrics.find((metric) => metric.key === key);
    if (subMetric) {
      subMetric.value = value;
    }
  }

  getReturnsKpiCardsData() {
    this.returnsKpiCardsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: KpiCardsResponse) => {
        if (apiData) {
          this.kpiCardsLoading = false;
          let cancelRequests = 0;

          if (apiData.cards && apiData.cards.length > 0) {
            apiData.cards.forEach((card: KpiCard) => {
              if (card.key === KpiCardKey.CancelRequests) {
                cancelRequests = card.value;
                this.returnsTopCards[ReturnsCardIndex.ReturnRequests].value = card.value.toLocaleString();
                this.applyReturnsTrend(this.returnsTopCards[ReturnsCardIndex.ReturnRequests], card.trend_pct);
                this.returnsTopCards[ReturnsCardIndex.ReturnRequests].previousValueLabel =
                  this.formatReturnsPreviousValue(card.previous_value);
              } else if (card.key === KpiCardKey.Saved) {
                this.returnsTopCards[ReturnsCardIndex.ReturnsDeflected].value = card.value.toLocaleString();
                this.applyReturnsTrend(this.returnsTopCards[ReturnsCardIndex.ReturnsDeflected], card.trend_pct);
                this.returnsTopCards[ReturnsCardIndex.ReturnsDeflected].previousValueLabel =
                  this.formatReturnsPreviousValue(card.previous_value);
                this.setReturnsSubMetric(
                  this.returnsTopCards[ReturnsCardIndex.ReturnRequests],
                  ReturnsKpiSubMetricKey.Deflected,
                  card.value.toLocaleString(),
                );
                if (card.pct !== null) {
                  this.setReturnsSubMetric(
                    this.returnsTopCards[ReturnsCardIndex.ReturnsDeflected],
                    ReturnsKpiSubMetricKey.DeflectionRate,
                    `${card.pct.toFixed(1)}%`,
                  );
                }
              } else if (card.key === KpiCardKey.Cancelled) {
                this.setReturnsSubMetric(
                  this.returnsTopCards[ReturnsCardIndex.ReturnRequests],
                  ReturnsKpiSubMetricKey.Completed,
                  card.value.toLocaleString(),
                );
              } else if (card.key === KpiCardKey.Abandoned) {
                this.setReturnsSubMetric(
                  this.returnsTopCards[ReturnsCardIndex.ReturnRequests],
                  ReturnsKpiSubMetricKey.Abandoned,
                  card.value.toLocaleString(),
                );
              }
            });
          }

          this.returnsCancelRequestsCount = cancelRequests;
          this.recomputeReturnsAvgRequest();
        }
      });
  }

  getReturnsMoneyCardsData() {
    this.returnsMoneyCardsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: MoneyCardsResponse) => {
        if (apiData) {
          this.returnsMoneyCardsLoading = false;
          if (apiData.cards && apiData.cards.length > 0) {
            apiData.cards.forEach((card: MoneyCard) => {
              const formattedDecimal = `$${formatMoney(card.amount)}`;
              if (card.key === MoneyCardKey.TotalBilled) {
                this.returnsTopCards[ReturnsCardIndex.RequestedReturnValue].value = formattedDecimal;
                this.applyReturnsTrend(this.returnsTopCards[ReturnsCardIndex.RequestedReturnValue], card.trend_pct);
                this.returnsTopCards[ReturnsCardIndex.RequestedReturnValue].previousValueLabel =
                  this.formatReturnsPreviousMoney(card.previous_value);
                this.returnsTotalBilledAmount = card.amount;
                this.recomputeReturnsAvgRequest();
              } else if (card.key === MoneyCardKey.RevenueSaved) {
                const pctSuffix = card.pct !== null && card.pct !== undefined ? ` (${card.pct.toFixed(1)}%)` : '';
                this.setReturnsSubMetric(
                  this.returnsTopCards[ReturnsCardIndex.ReturnsDeflected],
                  ReturnsKpiSubMetricKey.RevenueSaved,
                  `${formattedDecimal}${pctSuffix}`,
                );
              } else if (card.key === MoneyCardKey.RevenueAbandoned) {
                this.setReturnsSubMetric(
                  this.returnsTopCards[ReturnsCardIndex.RequestedReturnValue],
                  ReturnsKpiSubMetricKey.RevenueAbandoned,
                  formattedDecimal,
                );
              } else if (card.key === MoneyCardKey.TotalRefunds) {
                this.setReturnsSubMetric(
                  this.returnsTopCards[ReturnsCardIndex.CreditsIssued],
                  ReturnsKpiSubMetricKey.CreditValue,
                  formattedDecimal,
                );
              } else if (card.key === MoneyCardKey.CreditsIssued) {
                this.returnsTopCards[ReturnsCardIndex.CreditsIssued].value = formattedDecimal;
                this.applyReturnsTrend(this.returnsTopCards[ReturnsCardIndex.CreditsIssued], card.trend_pct);
                this.returnsTopCards[ReturnsCardIndex.CreditsIssued].previousValueLabel =
                  this.formatReturnsPreviousMoney(card.previous_value);
              } else if (card.key === MoneyCardKey.CreditsAvg) {
                this.setReturnsSubMetric(
                  this.returnsTopCards[ReturnsCardIndex.CreditsIssued],
                  ReturnsKpiSubMetricKey.AvgCredit,
                  formattedDecimal,
                );
              }
            });
          }
        }
      });
  }

  getReturnsRetentionSummaryData() {
    this.returnsRetentionSummaryService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: RetentionSummaryV2Response) => {
        if (apiData) {
          this.returnsOutcomesData.loading = false;
          this.returnsOutcomesData.noData = false;

          if (isObjectEmpty(apiData)) {
            this.returnsOutcomesData.noData = true;
          } else {
            const completed = apiData.items_cancelled || 0;
            const deflected = apiData.items_saved || 0;
            const abandoned = apiData.items_abandoned || 0;
            const outcomes = [completed, deflected, abandoned];
            const total = completed + deflected + abandoned;

            if (total === 0) {
              this.returnsOutcomesData.noData = true;
            } else {
              this.returnsOutcomesData.data = outcomes;
              this.returnsOutcomesData.total = total.toLocaleString();
            }

            outcomes.forEach((value, index) => {
              this.returnsOutcomesLegend[index].value = value.toLocaleString();
              this.returnsOutcomesLegend[index].percentage = total > 0 ? `${((value / total) * 100).toFixed(2)}%` : '0%';
            });
          }
        }
      });
  }

  getReturnsOpenActivityData() {
    this.returnsOpenActivityService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: OpenReturnActivityResponse) => {
        if (apiData) {
          this.returnsActivityLoading = false;
          if (!apiData.pending) {
            this.returnsActivityStats[0].count = (apiData.pending_returns || 0).toLocaleString();
            this.returnsActivityStats[0].value = `$${formatMoney(apiData.pending_value)}`;
            this.returnsActivityStats[1].count = (apiData.expired_returns || 0).toLocaleString();
            this.returnsActivityStats[1].value = `$${formatMoney(apiData.expired_value)}`;
          }
        }
      });
  }

  getReturnsReasonsData() {
    this.returnsReasonsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: TopCancellationReasonsResponse) => {
        if (apiData) {
          this.returnsReasons.loading = false;
          this.returnsReasons.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.returnsReasons.data = apiData.results.map((item: CancellationReasonRow): ReturnsTableRow => ({
              name: item.reason,
              requests: item.requests.toLocaleString(),
              value: `$${formatMoney(item.value)}`,
              deflection: item.requests > 0 ? `${((item.saved / item.requests) * 100).toFixed(1)}%` : '0%',
            }));
          } else {
            this.returnsReasons.noData = true;
            this.returnsReasons.data = [];
          }
        }
      });
  }

  getReturnsProductsData() {
    this.returnsProductService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: PerformanceTableResponse) => {
        if (apiData) {
          this.returnsProducts.loading = false;
          this.returnsProducts.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.returnsProducts.data = apiData.results.map((item: PerformanceRow): ProductReturnPerfRow => ({
              name: item.dimension_id
                ? `${item.dimension} (ID: ${item.dimension_id})`
                : String(item.dimension) || '--',
              requests: item.requests.toLocaleString(),
              value: `$${formatMoney(item.value)}`,
              deflected: item.saves.toLocaleString(),
              deflectionRate: `${item.save_pct.toFixed(2)}%`,
            }));
          } else {
            this.returnsProducts.noData = true;
            this.returnsProducts.data = [];
          }
        }
      });
  }

  getReturnsOffersData() {
    this.returnsOffersService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: TopOffersResponse) => {
        if (apiData) {
          this.returnsOffers.loading = false;
          this.returnsOffers.noData = false;

          if (apiData.results && apiData.results.length > 0) {
            this.returnsOffers.data = apiData.results.map((item: ReturnsOfferApiRow): ReturnsOfferRow => ({
              name: item.offer_name,
              presented: item.total_impressions.toLocaleString(),
              accepted: item.total_accepted.toLocaleString(),
              acceptance: `${item.accepted_pct.toFixed(1)}%`,
              revenueSaved: `$${formatMoney(item.total_saved)}`,
            }));
          } else {
            this.returnsOffers.noData = true;
            this.returnsOffers.data = [];
          }
        }
      });
  }

  getReturnsAiInsightsData() {
    this.returnsAiInsightsService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((apiData: AiInsightsResponse) => {
        if (apiData) {
          this.returnsAiInsights.loading = false;
          this.returnsAiInsights.noData = false;

          if (apiData.insights && apiData.insights.length > 0) {
            this.returnsAiInsights.data = apiData.insights.map((item: AiInsightApiRow): ReturnsAiInsight => {
              let iconInfo = ReturnsAiInsightIconMap[item.rule];
              // deflection_trend is bidirectional (backend direction is 'improved' or 'declined'),
              // so its icon can't be a static per-rule entry like the others.
              if (item.rule === ReturnsAiInsightRule.DeflectionTrend && item.text.toLowerCase().indexOf('declined') !== -1) {
                iconInfo = { icon: '/assets/IconsLibrary/ai-insights-deflection-down-icon.svg', iconBg: 'rgba(239, 68, 68, 0.1)' };
              }
              return {
                icon: iconInfo.icon,
                iconBg: iconInfo.iconBg,
                text: item.text,
              };
            });
          } else {
            this.returnsAiInsights.noData = true;
            this.returnsAiInsights.data = [];
          }
        }
      });
  }

  get isRetentionDashboard(): boolean {
    return (
      this.selectedSection === DashboardSections.Subscription ||
      this.selectedSection === DashboardSections.Order ||
      this.selectedSection === DashboardSections.Return
    );
  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.unsubscribe();
  }
}
